(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _propTypes = require("prop-types");

var _AppStateContext = require("./lib/AppStateContext.jsx");

var _DomainSelector = _interopRequireDefault(require("./components/DomainSelector/DomainSelector.jsx"));

var _Map = _interopRequireDefault(require("./components/Map/Map.jsx"));

var _Ranking = _interopRequireDefault(require("./components/Ranking/Ranking.jsx"));

var _domains = require("./common/domains.js");

var _locations = require("./common/locations.js");

var S = _interopRequireWildcard(require("./AppStyles.js"));

var _topojson = require("topojson");

var _Overall = _interopRequireDefault(require("./components/Indicators/Overall.jsx"));

var _Domain = _interopRequireDefault(require("./components/Indicators/Domain.jsx"));

var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));

var _StateHeader = _interopRequireDefault(require("./components/StateHeader/StateHeader.jsx"));

var _InstructionText = _interopRequireDefault(require("./components/InstructionText/InstructionText.jsx"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propTypes = {
  pdfUrl: _propTypes.string.isRequired
}; // <AnimateHeight> duration

var DURATION = 500; // memoized so this only runs when needed

var getLocationRanksForDomain = (0, _memoizeOne.default)(function (data, selectedDomainId) {
  var locationRanks = _ramda.default.compose(_ramda.default.map(function (location) {
    return _objectSpread({}, _ramda.default.path(["domains", selectedDomainId], location), (0, _locations.byId)(location.id));
  }), _ramda.default.pick(_ramda.default.pluck("id", _locations.states)) // only states, no us/regions
  )(data); // quartiles are for the rankings, so exclude any states that don't have a rank


  var quartiles = _ramda.default.compose(_ramda.default.map(_ramda.default.sortBy(_ramda.default.prop("rank"))), _ramda.default.values, _ramda.default.groupBy(_ramda.default.prop("quartile")), _ramda.default.reject(_ramda.default.propSatisfies(_ramda.default.isNil, "rank")), _ramda.default.values)(locationRanks);

  return {
    locationRanks: locationRanks,
    quartiles: quartiles
  };
});

var App = function App(props) {
  var _useContext = (0, _react.useContext)(_AppStateContext.AppStateContext),
      _useContext$appState = _useContext.appState,
      geojson = _useContext$appState.geojson,
      hoveredStateId = _useContext$appState.hoveredStateId,
      selectedDomainId = _useContext$appState.selectedDomainId,
      selectedLocationId = _useContext$appState.selectedLocationId,
      data = _useContext$appState.data,
      dataRoot = _useContext$appState.dataRoot,
      _useContext$actions = _useContext.actions,
      resetLocation = _useContext$actions.resetLocation,
      setHoveredStateId = _useContext$actions.setHoveredStateId,
      setLocation = _useContext$actions.setLocation,
      setDomain = _useContext$actions.setDomain,
      setGeojson = _useContext$actions.setGeojson,
      dispatch = _useContext.dispatch;

  var pdfUrl = props.pdfUrl;

  var _getLocationRanksForD = getLocationRanksForDomain(data, selectedDomainId),
      locationRanks = _getLocationRanksForD.locationRanks,
      quartiles = _getLocationRanksForD.quartiles;

  var selectedDomain = (0, _domains.byId)(selectedDomainId);
  var selectedLocation = (0, _locations.byId)(selectedLocationId);
  (0, _react.useEffect)(function () {
    // load map data
    fetch(dataRoot + "/states.topojson.json").then(function (res) {
      return res.json();
    }).then(function (json) {
      // https://github.com/mbostock/topojson
      // transpile the TopoJSON data to GeoJSON data that d3 can understand
      return (0, _topojson.feature)(json, json.objects.states);
    }).then(function (json) {
      return dispatch(setGeojson(json));
    });
  }, [dataRoot, dispatch, setGeojson]);
  (0, _react.useEffect)(function () {
    var handleKeydown = function handleKeydown(e) {
      if (e.key === "Escape") {
        dispatch(resetLocation());
      }
    };

    if (selectedLocationId) {
      window.addEventListener("keydown", handleKeydown);
    }

    return function () {
      return window.removeEventListener("keydown", handleKeydown);
    };
  }, [dispatch, resetLocation, selectedLocationId]);

  var handleDomainClick = function handleDomainClick(domain) {
    return dispatch(setDomain(domain.id));
  };

  var getDataForLocation = function getDataForLocation(locationId) {
    return _ramda.default.mergeRight(data[locationId], (0, _locations.byId)(locationId));
  };

  var locationData = getDataForLocation(selectedLocationId);
  var regionData = [getDataForLocation(_locations.usa.id)].concat(_toConsumableArray(_ramda.default.compose(_ramda.default.map(getDataForLocation), _ramda.default.pluck("id"))(_locations.regions)));
  var renderOverall = selectedLocationId && selectedDomain.id === "overall";
  var renderDomain = selectedLocationId && selectedDomain.id !== "overall"; // The page is jumping when <Overall> or <Domain> aren't being rendered,
  // so we need to render a placeholder so the <AnimateHeight> has content
  // to animate away

  var renderAnimationPlaceholder = function renderAnimationPlaceholder() {
    return _react.default.createElement("div", {
      style: {
        height: "100vh"
      }
    });
  };

  return _react.default.createElement(S.Container, null, _react.default.createElement(S.Title, null, _react.default.createElement("h1", null, "2024 KIDS COUNT Data Book Interactive"), _react.default.createElement(S.SubHeader, null, _react.default.createElement(_InstructionText.default, null, "We track overall child well-being along four domains. Start exploring data."), _react.default.createElement(S.DownloadButton, {
    href: pdfUrl,
    target: "_blank"
  }, "Read or Download the Data Book", _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-download"
  }, _react.default.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), _react.default.createElement("polyline", {
    points: "7 10 12 15 17 10"
  }), _react.default.createElement("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "3"
  }))))), _react.default.createElement(_DomainSelector.default, {
    selectedDomain: selectedDomain,
    onDomainClick: handleDomainClick
  }), _react.default.createElement(_InstructionText.default, null, _ramda.default.isNil(selectedLocation) ? selectedDomain.mapInstruction : selectedDomain.locationInstruction), _react.default.createElement(S.MapAndStateHeader, null, _react.default.createElement(S.MapContainer, null, _react.default.createElement(_Map.default, {
    domain: selectedDomain,
    selectedLocation: selectedLocation,
    onDeselect: function onDeselect() {
      return dispatch(resetLocation());
    },
    onStateSelect: function onStateSelect(id) {
      return dispatch(setLocation(id));
    },
    geojson: geojson,
    hoveredStateId: hoveredStateId,
    onStateHover: function onStateHover(id) {
      return dispatch(setHoveredStateId(id));
    },
    locationRanks: locationRanks
  })), _react.default.createElement(S.StateHeaderContainer, null, _react.default.createElement(_StateHeader.default, {
    location: locationRanks[selectedLocationId] || _locations.usa,
    domain: selectedDomain,
    pdfUrl: pdfUrl
  }))), _react.default.createElement(_reactAnimateHeight.default, {
    height: selectedLocationId ? 0 : "auto",
    duration: DURATION
  }, _react.default.createElement(_Ranking.default, {
    domain: selectedDomain,
    selectedStateId: selectedLocationId,
    hoveredStateId: hoveredStateId,
    onStateHover: function onStateHover(id) {
      return dispatch(setHoveredStateId(id));
    },
    onStateClick: function onStateClick(location) {
      return dispatch(setLocation(location.id));
    },
    quartiles: quartiles
  })), _react.default.createElement(_reactAnimateHeight.default, {
    height: renderOverall ? "auto" : 0,
    duration: DURATION
  }, renderOverall ? _react.default.createElement(_Overall.default, {
    onDomainClick: handleDomainClick,
    location: locationData
  }) : renderAnimationPlaceholder()), _react.default.createElement(_reactAnimateHeight.default, {
    height: renderDomain ? "auto" : 0,
    duration: DURATION
  }, renderDomain ? _react.default.createElement(_Domain.default, {
    domain: _ramda.default.mergeRight(locationData[selectedDomain.id], selectedDomain),
    location: locationData,
    regionData: regionData
  }) : renderAnimationPlaceholder()));
};

App.propTypes = propTypes;
var _default = App;
exports.default = _default;

},{"./AppStyles.js":3,"./common/domains.js":6,"./common/locations.js":10,"./components/DomainSelector/DomainSelector.jsx":20,"./components/Indicators/Domain.jsx":23,"./components/Indicators/Overall.jsx":27,"./components/InstructionText/InstructionText.jsx":28,"./components/Map/Map.jsx":32,"./components/Ranking/Ranking.jsx":43,"./components/StateHeader/StateHeader.jsx":46,"./lib/AppStateContext.jsx":48,"memoize-one":"memoize-one","prop-types":"prop-types","ramda":"ramda","react":"react","react-animate-height":"react-animate-height","topojson":"topojson"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleUrlChange = exports.mapStateToUrl = exports.actions = exports.reducer = exports.initialState = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

var _domains = require("./common/domains.js");

var _locations = require("./common/locations.js");

var _compareBy = require("./common/compareBy.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Initial state */
var initialState = {
  compareByOptions: _compareBy.compareByOptions,
  data: undefined,
  geojson: undefined,
  hoveredStateId: undefined,
  selectedDomainId: _domains.domains[0].id,
  selectedLocationId: undefined,
  selectedCompareById: _compareBy.compareByOptions[0].id
};
/**
 * Action handlers
 * the `action` functions will be included in the `actions` export below.
 * `reducer` chooses the reducer function based on the action key, so the
 * action type and the actionHandlers key need to match
 */

exports.initialState = initialState;
var actionHandlers = {
  setDomain: {
    action: function action(selectedDomainId) {
      return {
        type: "setDomain",
        payload: {
          selectedDomainId: selectedDomainId
        }
      };
    },
    reducer: function reducer(state, action) {
      // default to the initialState if the given domainId is invalid
      var selectedDomainId = _ramda.default.compose(_ramda.default.unless(_domains.isValidDomainId, function () {
        return initialState.selectedDomainId;
      }), _ramda.default.path(["payload", "selectedDomainId"]))(action);

      return _objectSpread({}, state, {
        selectedDomainId: selectedDomainId
      });
    }
  },
  setLocation: {
    action: function action(selectedLocationId) {
      return {
        type: "setLocation",
        payload: {
          selectedLocationId: selectedLocationId
        }
      };
    },
    reducer: function reducer(state, action) {
      // default to the initialState if the given locationId is invalid
      var selectedLocationId = _ramda.default.compose(_ramda.default.unless(_locations.isValidLocationId, function () {
        return initialState.selectedLocationId;
      }), _ramda.default.path(["payload", "selectedLocationId"]))(action); // reset the compareById if needed


      var selectedCompareById = _ramda.default.unless((0, _compareBy.isValidCompareById)(selectedLocationId), function () {
        return initialState.selectedCompareById;
      }, state.selectedCompareById); // when a location is selected, unset any hovered state


      return _objectSpread({}, state, {
        compareByOptions: _compareBy.compareByOptions,
        selectedLocationId: selectedLocationId,
        selectedCompareById: selectedCompareById,
        hoveredStateId: undefined
      });
    }
  },
  resetLocation: {
    action: function action() {
      return {
        type: "resetLocation"
      };
    },
    reducer: function reducer(state, action) {
      var setLocation = actionHandlers.setLocation;
      return setLocation.reducer(state, setLocation.action());
    }
  },
  setHoveredStateId: {
    action: function action(hoveredStateId) {
      return {
        type: "setHoveredStateId",
        payload: {
          hoveredStateId: hoveredStateId
        }
      };
    },
    reducer: function reducer(state, action) {
      var hoveredStateId = action.payload.hoveredStateId;
      return _objectSpread({}, state, {
        hoveredStateId: hoveredStateId
      });
    }
  },
  setCompareById: {
    action: function action(selectedCompareById) {
      return {
        type: "setCompareById",
        payload: {
          selectedCompareById: selectedCompareById
        }
      };
    },
    reducer: function reducer(state, action) {
      // default to the initialState if the given compareById is invalid
      var selectedCompareById = _ramda.default.compose(_ramda.default.unless((0, _compareBy.isValidCompareById)(state.selectedLocationId), function () {
        return initialState.selectedCompareById;
      }), _ramda.default.path(["payload", "selectedCompareById"]))(action);

      return _objectSpread({}, state, {
        selectedCompareById: selectedCompareById
      });
    }
  },
  setGeojson: {
    action: function action(geojson) {
      return {
        type: "setGeojson",
        payload: {
          geojson: geojson
        }
      };
    },
    reducer: function reducer(state, action) {
      var geojson = action.payload.geojson;
      return _objectSpread({}, state, {
        geojson: geojson
      });
    }
  }
};
/**
 * Reducer
 * Looks in the `actionHandlers` object for a key that mathces `action.type`
 * if it finds it, run the associated reducer.
 */

var reducer = function reducer(state, action) {
  // console.log(action.type, action.payload);
  if (actionHandlers[action.type]) {
    return actionHandlers[action.type].reducer(state, action);
  } // if an action wasn't found, log a warning


  console.warn("Action not found!", action);
  return state;
};
/**
 * Actions
 * an abject with keys of action functions. eg { increment, decrement, reset, ...}
 */


exports.reducer = reducer;

var actions = _ramda.default.pluck("action", actionHandlers);
/**
 * Query string state
 *
 * functions to sync the AppState with the query-string.
 */
// given the app state, return an object of values to be in the url query-string


exports.actions = actions;

var mapStateToUrl = function mapStateToUrl(appState) {
  return {
    d: appState.selectedDomainId,
    l: appState.selectedLocationId,
    c: appState.selectedCompareById
  };
}; // given the searchParams from the url, update the conxtet to match


exports.mapStateToUrl = mapStateToUrl;

var handleUrlChange = function handleUrlChange(searchParams, context, event) {
  var appState = context.appState,
      dispatch = context.dispatch,
      actions = context.actions;

  if (searchParams.d !== appState.selectedDomainId) {
    dispatch(actions.setDomain(searchParams.d));
  }

  if (searchParams.l !== appState.selectedLocationId) {
    dispatch(actions.setLocation(searchParams.l));
  }

  if (searchParams.c !== appState.selectedCompareById) {
    dispatch(actions.setCompareById(searchParams.c));
  }
};

exports.handleUrlChange = handleUrlChange;

},{"./common/compareBy.js":4,"./common/domains.js":6,"./common/locations.js":10,"ramda":"ramda"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateHeaderContainer = exports.MapContainer = exports.MapAndStateHeader = exports.SubHeader = exports.DownloadButton = exports.Title = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = require("./styles/color.js");

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "AppStyles__Container",
  componentId: "sc-18pr6h2-0"
})(["width:1200px;max-width:100%;box-sizing:border-box;margin:auto;padding:24px 12px 200px;font-family:\"Source Sans Pro\",sans-serif;button{font-family:\"Source Sans Pro\",sans-serif;}h1{color:", ";font-size:30px;font-weight:700;}"], _color.caseyGrey);

exports.Container = Container;

var Title = _styledComponents.default.div.withConfig({
  displayName: "AppStyles__Title",
  componentId: "sc-18pr6h2-1"
})(["display:block;margin-bottom:40px;"]);

exports.Title = Title;

var DownloadButton = _styledComponents.default.a.withConfig({
  displayName: "AppStyles__DownloadButton",
  componentId: "sc-18pr6h2-2"
})(["display:inline-flex;align-items:center;margin:0;padding:10px 30px;color:", ";font-size:14px;line-height:18px;letter-spacing:0.5px;text-align:center;text-decoration:none;text-transform:uppercase;background-color:", ";border:0;border-radius:1.25rem;cursor:pointer;svg{margin-left:8px;}> *{flex:none;}"], (0, _polished.readableColor)((0, _color.quartileColor)("overall", 0)), (0, _color.quartileColor)("overall", 0));

exports.DownloadButton = DownloadButton;

var SubHeader = _styledComponents.default.div.withConfig({
  displayName: "AppStyles__SubHeader",
  componentId: "sc-18pr6h2-3"
})(["display:flex;align-items:center;flex-wrap:wrap;justify-content:space-between;* >{flex:none;}"]);

exports.SubHeader = SubHeader;

var MapAndStateHeader = _styledComponents.default.div.withConfig({
  displayName: "AppStyles__MapAndStateHeader",
  componentId: "sc-18pr6h2-4"
})(["display:flex;align-items:star;flex-wrap:wrap;justify-content:space-between;"]);

exports.MapAndStateHeader = MapAndStateHeader;

var MapContainer = _styledComponents.default.div.withConfig({
  displayName: "AppStyles__MapContainer",
  componentId: "sc-18pr6h2-5"
})(["max-width:59%;@media (max-width:768px){max-width:100%;}"]);

exports.MapContainer = MapContainer;

var StateHeaderContainer = _styledComponents.default.div.withConfig({
  displayName: "AppStyles__StateHeaderContainer",
  componentId: "sc-18pr6h2-6"
})(["max-width:39%;@media (max-width:768px){max-width:100%;}"]);

exports.StateHeaderContainer = StateHeaderContainer;

},{"./styles/color.js":51,"polished":"polished","styled-components":"styled-components"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidCompareById = exports.compareByShape = exports.compareByOptions = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compareByOptions = [{
  id: "change",
  label: "Change"
}, {
  id: "race",
  label: "Race"
}, {
  id: "region",
  label: "Region"
}];
exports.compareByOptions = compareByOptions;
var compareByShape = (0, _propTypes.oneOf)(_ramda.default.pluck("id", compareByOptions));
exports.compareByShape = compareByShape;

var isValidCompareById = _ramda.default.curry(function (locationId, compareById) {
  return _ramda.default.compose(_ramda.default.includes(compareById), _ramda.default.pluck("id"))(compareByOptions);
});

exports.isValidCompareById = isValidCompareById;

},{"prop-types":"prop-types","ramda":"ramda"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataTypes = exports.getFormatter = exports.getPercentageFormatter = exports.numberFormatter = void 0;

var _d3Format = require("d3-format");

var numberFormatter = (0, _d3Format.format)(",");
exports.numberFormatter = numberFormatter;

var getPercentageFormatter = function getPercentageFormatter(fractionalPartLength) {
  return fractionalPartLength ? (0, _d3Format.format)(".".concat(fractionalPartLength, "%")) : (0, _d3Format.format)(".2~%");
};

exports.getPercentageFormatter = getPercentageFormatter;

var getFormatter = function getFormatter(dataType, fractionalPartLength) {
  return dataType === "percentage" ? getPercentageFormatter(fractionalPartLength) : numberFormatter;
};

exports.getFormatter = getFormatter;
var dataTypes = ["percentage", "number"];
exports.dataTypes = dataTypes;

},{"d3-format":"d3-format"}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidDomainId = exports.byId = exports.domains = exports.domainShape = exports.domainDataShape = exports.domainMetadataShape = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

var _propTypes = require("prop-types");

var _indicatorsMetadata = _interopRequireDefault(require("./indicatorsMetadata.js"));

var _domainsMetadata = _interopRequireDefault(require("./domainsMetadata.js"));

var _indicators = require("./indicators.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var domainMetadata = {
  id: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  color: _propTypes.string.isRequired,
  nationDescription: _propTypes.string.isRequired,
  rankInstruction: _propTypes.string.isRequired,
  mapInstruction: _propTypes.string.isRequired,
  locationInstruction: _propTypes.string.isRequired,
  indicators: (0, _propTypes.arrayOf)(_indicators.indicatorMetadataShape)
};
var domainMetadataShape = (0, _propTypes.shape)(domainMetadata);
exports.domainMetadataShape = domainMetadataShape;
var domainData = {
  rank: _propTypes.number,
  // U.S. doesn't have a rank
  quartile: _propTypes.number
};
var domainDataShape = (0, _propTypes.shape)(domainData);
exports.domainDataShape = domainDataShape;
var domainShape = (0, _propTypes.shape)(_objectSpread({}, domainMetadata, domainData)); // add the indicators to the domains metadata. The indicators comes from the client
// via indicators-metadata.csv, then munched into ./indicatorsMetadata.js

exports.domainShape = domainShape;

var domains = _ramda.default.map(function (domain) {
  return _ramda.default.when(function () {
    return _ramda.default.has(domain.id, _indicatorsMetadata.default);
  }, _ramda.default.assoc("indicators", _indicatorsMetadata.default[domain.id]), domain);
})(_domainsMetadata.default); // provide the ability to lookup a domain by id


exports.domains = domains;

var domainsById = _ramda.default.indexBy(_ramda.default.prop("id"), domains);

var byId = function byId(id) {
  return _ramda.default.prop(id, domainsById);
};
/**
 * validate the given domain Id against the "id" field of domains
 * @param {String} domainId : A domainId to validate
 */


exports.byId = byId;

var isValidDomainId = function isValidDomainId(domainId) {
  return _ramda.default.compose(_ramda.default.includes(domainId), _ramda.default.pluck("id"))(domains);
};

exports.isValidDomainId = isValidDomainId;

},{"./domainsMetadata.js":7,"./indicators.js":8,"./indicatorsMetadata.js":9,"prop-types":"prop-types","ramda":"ramda"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// domains without the indicators.
var _default = [{
  id: "overall",
  name: "Overall Child Well-Being",
  color: "#F36F21",
  quartileColors: ["#FCC199", "#F9A56F", "#F68A47", "#F36F21"],
  description: "In the <i>2024 KIDS COUNT Data Book</i>, New England states hold two of the top three spots for overall child well-being. New Hampshire ranks first, followed by Massachusetts and Utah. Louisiana (48th), Mississippi (49th) and New Mexico (50th) are the three lowest-ranked states. A child’s chances of thriving depend not only on individual, family and community characteristics but also on the state in which they are born and raised. States vary in their wealth and other resources. Policy choices and investments also influence children’s chances for success.",
  nationDescription: "This year’s <i>KIDS COUNT Data Book</i> presents a picture of child well-being as the nation recovered from the COVID-19 pandemic. Comparisons are made between 2019 and 2022 where possible.<br /><br />During this time, six indicators worsened, while four stayed the same and five improved. The child poverty rate dropped and the employment security of parents returned to pre-pandemic levels. At the same time, educational achievement was hit hard and the child and teen death rate climbed.",
  rankInstruction: "Select a location to see how it ranks and performs on 16 key indicators.",
  mapInstruction: "Select a location to see how it ranks and performs on 16 key indicators.",
  locationInstruction: "Scroll to see how this location ranks and performs on 16 key indicators."
}, {
  id: "ec",
  name: "Economic Well-Being",
  color: "#85991b",
  quartileColors: ["#C6D29B", "#BAC45B", "#99AC3A", "#617E20"],
  description: "To help children grow into prepared, productive adults, parents need jobs with family-sustaining pay, affordable housing and the ability to invest in their children’s future. When parents are unemployed or earn low wages, their access to resources to support their kids’ development is more limited, which can undermine their children’s health and prospects for success in school and beyond. The negative effects of poverty on kids can extend into their teenage years and young adulthood, as they are more likely to contend with issues such as teen pregnancy and failing to graduate from high school.",
  nationDescription: "To help children grow into prepared, productive adults, parents need jobs with family-sustaining pay, affordable housing and the ability to invest in their children’s future. When parents are unemployed or earn low wages, their access to resources to support their kids’ development is more limited, which can undermine their children’s health and prospects for success in school and beyond. The negative effects of poverty on kids can extend into their teenage years and young adulthood, as they are more likely to contend with issues such as teen pregnancy and failing to graduate from high school.",
  rankInstruction: "Select a location to see how it performs on this domain’s four indicators.",
  mapInstruction: "Select a location to see how it performs on this domain’s four indicators.",
  locationInstruction: "Scroll to see how this location ranks and performs on this domain’s four indicators."
}, {
  id: "ed",
  name: "Education",
  color: "#5e589a",
  quartileColors: ["#C8C7E2", "#8A8BB9", "#64659D", "#4B4980"],
  description: "The early years of a child’s life lay the foundation for lifelong success. Establishing the conditions that promote educational achievement for children is critical, beginning with quality prenatal care and continuing through the early elementary years. Adolescence also represents a pivotal window for growth and developmental opportunities that equip youth to remain on track to graduate from high school, pursue postsecondary education and training and successfully transition to adulthood. Yet our country continues to have significant gaps in educational achievement by race and income among all age groups of child development. Closing these gaps will be key to ensuring the nation’s future workforce can compete on a global scale.",
  nationDescription: "The early years of a child’s life lay the foundation for lifelong success. Establishing the conditions that promote educational achievement for children is critical, beginning with quality prenatal care and continuing through the early elementary years. Adolescence also represents a pivotal window for growth and developmental opportunities that equip youth to remain on track to graduate from high school, pursue postsecondary education and training and successfully transition to adulthood. Yet our country continues to have significant gaps in educational achievement by race and income among all age groups of child development. Closing these gaps will be key to ensuring the nation’s future workforce can compete on a global scale.",
  rankInstruction: "Select a location to see how it performs on this domain’s four indicators.",
  mapInstruction: "Select a location to see how it performs on this domain’s four indicators.",
  locationInstruction: "Scroll to see how this location ranks and performs on this domain’s four indicators."
}, {
  id: "h",
  name: "Health",
  color: "#117CA7",
  quartileColors: ["#98C7EB", "#4CABE0", "#2683B5", "#20618F"],
  description: "Children’s good health is fundamental to their overall development, and ensuring kids are born healthy is the first step toward improving their life chances. Exposure to violence, family stress, inadequate housing, lack of preventive health care, poor nutrition, poverty and substance abuse undermine children’s health. Poor health in childhood affects other critical aspects of children’s lives, such as school readiness and attendance, and can have lasting consequences on their future health and well-being.",
  nationDescription: "Children’s good health is fundamental to their overall development, and ensuring kids are born healthy is the first step toward improving their life chances. Exposure to violence, family stress, inadequate housing, lack of preventive health care, poor nutrition, poverty and substance abuse undermine children’s health. Poor health in childhood affects other critical aspects of children’s lives, such as school readiness and attendance, and can have lasting consequences on their future health and well-being.",
  rankInstruction: "Select a location to see how it performs on this domain’s four indicators.",
  mapInstruction: "Select a location to see how it performs on this domain’s four indicators.",
  locationInstruction: "Scroll to see how this location ranks and performs on this domain’s four indicators."
}, {
  id: "fc",
  name: "Family and Community",
  color: "#c63052",
  quartileColors: ["#EEA9A0", "#E6827D", "#DF595F", "#D81F46"],
  description: "Children who live in nurturing families and supportive communities have stronger personal connections and higher academic achievement. Parents struggling with financial hardship have fewer resources available to foster their children’s development and are more prone to face severe stress and depression, which can interfere with effective parenting. These findings underscore the importance of two-generation approaches to ending poverty, which address the needs of parents and children at the same time so that both can succeed together. Where families live also matters. When communities are safe and have strong institutions, good schools and quality support services, families and their children are more likely to thrive.",
  nationDescription: "Children who live in nurturing families and supportive communities have stronger personal connections and higher academic achievement. Parents struggling with financial hardship have fewer resources available to foster their children’s development and are more prone to face severe stress and depression, which can interfere with effective parenting. These findings underscore the importance of two-generation approaches to ending poverty, which address the needs of parents and children at the same time so that both can succeed together. Where families live also matters. When communities are safe and have strong institutions, good schools and quality support services, families and their children are more likely to thrive.",
  rankInstruction: "Select a location to see how it performs on this domain’s four indicators.",
  mapInstruction: "Select a location to see how it performs on this domain’s four indicators.",
  locationInstruction: "Scroll to see how this location ranks and performs on this domain’s four indicators."
}];
exports.default = _default;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indicatorDataShape = exports.indicatorMetadataShape = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

var _propTypes = require("prop-types");

var _domainsMetadata = _interopRequireDefault(require("./domainsMetadata.js"));

var _dataTypes = require("./dataTypes.js");

var _compareBy = require("./compareBy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var otherDomains = _ramda.default.reject(_ramda.default.propEq("id", "overall"), _domainsMetadata.default);

var indicatorMetadataShape = (0, _propTypes.shape)({
  baseline: _propTypes.string.isRequired,
  current: _propTypes.string.isRequired,
  currentRace: _propTypes.string.isRequired,
  dataType: (0, _propTypes.oneOf)(_dataTypes.dataTypes).isRequired,
  fractionalPartLength: _propTypes.string,
  domainId: (0, _propTypes.oneOf)(_ramda.default.pluck("id", otherDomains)).isRequired,
  id: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  dataCenterIndicatorID: _propTypes.string,
  dataCenterRaceIndicatorID: _propTypes.string,
  description: _propTypes.string
});
exports.indicatorMetadataShape = indicatorMetadataShape;
var indicatorDataShape = (0, _propTypes.shape)({
  baselineValue: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  change: (0, _propTypes.oneOf)(["better", "same", "worse", "n.a."]).isRequired,
  currentValue: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,
  // the client can pass a number, or any string
  rawValue: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  raceData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string.isRequired,
    value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
    notes: _propTypes.string
  })),
  barChartCustomData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    compareBy: (0, _propTypes.oneOf)(_compareBy.compareByOptions),
    maxValue: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
  }))
});
exports.indicatorDataShape = indicatorDataShape;

},{"./compareBy":4,"./dataTypes.js":5,"./domainsMetadata.js":7,"prop-types":"prop-types","ramda":"ramda"}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// this file is generated from indicators-metadata.csv
// DO NOT EDIT
// see data/munch.js
var _default = {
  "ec": [{
    "id": "chp",
    "domainId": "ec",
    "name": "Children in poverty",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "Growing up in poverty is one of the greatest threats to healthy child development. It increases the likelihood that a child will be exposed to factors that can impair brain development and lead to poor academic, cognitive and health outcomes. It also can result in higher rates of risky health-related behaviors among adolescents. The official poverty level in 2022 was $29,678 for a family of two adults and two children. The risks posed by economic hardship are greatest among children who experience poverty when they are young and among those who experience persistent and deep poverty."
  }, {
    "id": "spe",
    "domainId": "ec",
    "name": "Children whose parents lack secure employment",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "Secure employment is a key contributor to the financial stability and well-being of families. Yet the COVID-19 pandemic pushed the unemployment rate to near record highs and caused millions to leave the labor market. In 2022, job openings reached a record high as the labor market recovered. Even so, employment insecurity is a reality for more than a quarter of families living in the United States. It disrupts daily living and relationships and limit families’ access to resources to invest in their children’s development."
  }, {
    "id": "hhb",
    "domainId": "ec",
    "name": "Children living in households with a high housing cost burden",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "Housing is typically one of the largest family expenses. High housing costs weigh more heavily on low-income families, which are more likely to struggle with finding affordable housing, often spending more than 30% of pretax income on a home, whether they rent or own. Paying too much for housing limits the resources families have for other necessities, such as child care, food, health care and transportation, as well as their ability to save and achieve financial stability."
  }, {
    "id": "nsw",
    "domainId": "ec",
    "name": "Teens not in school and not working",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "Teens ages 16 to 19 who are not in school or working are at high risk of experiencing negative outcomes as they transition to adulthood. Young people who drop out of high school, are involved in the justice system, become parents at a young age or age out of foster care are most likely to be out of school and work. Limited skills and work history — combined with few financial resources to invest in developing the necessary skills or qualifications — restrict access to good jobs as well as future higher wages. While students who drop out of school clearly face obstacles, many young people who have graduated from high school but are not working are also at a disadvantage in terms of achieving financial stability in adulthood."
  }],
  "ed": [{
    "id": "nps",
    "domainId": "ed",
    "name": "Young children (ages 3 and 4) not in school",
    "baseline": "2013–17",
    "current": "2018–22",
    "currentRace": "2018-22",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "High-quality preschool programs for 3- and 4-year-olds help set the stage for future skill development, well-being and learning, particularly for those from low-income housholds. These programs play an important role in preparing children for success and lead to higher levels of educational attainment, career advancement and earnings. Although Head Start and the expansion of state-funded programs since the 1990s have greatly increased access to preschool and kindergarten, many kids — especially 3-year-olds and children living in low-income families — continue to be left out, exacerbating socioeconomic differences in educational achievement."
  }, {
    "id": "rdg",
    "domainId": "ed",
    "name": "Fourth graders not proficient in reading",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "By fourth grade, children are expected to use reading to learn other subjects. Therefore, mastery of reading at this level becomes important for students to keep up academically. Children who reach fourth grade without being able to read proficiently are more likely to struggle academically and eventually drop out of school. Low reading proficiency also can reduce earning potential and chances for career success as adults. Although there have been improvements since the early 1990s, progress has been slow on literacy gains, and racial and income disparities remain. Unfortunately, the pandemic has erased progress made in reading proficiency levels."
  }, {
    "id": "mth",
    "domainId": "ed",
    "name": "Eighth graders not proficient in math",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "As technology continues to transform the economy, the demand grows for a workforce with aligned math and science skills and training that can keep pace with technological advancement. Students with strong math and science skills are more likely to graduate from high school, attend and complete college, earn higher incomes and take advantage of the future opportunities available to them. Basic math skills and numerical literacy help with everyday tasks and personal financial management and improve employability. Ensuring kids have early and ongoing access to high-quality math education is critical for their success in school and life."
  }, {
    "id": "acgr",
    "domainId": "ed",
    "name": "High school students not graduating on time",
    "baseline": "2018–19",
    "current": "2020–21",
    "currentRace": "2020–21",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "A high school diploma is critical for entering today’s workforce. Students who graduate from high school on time have many more choices in young adulthood. They are more likely to pursue postsecondary education and training, make healthier decisions and engage in less risky behaviors. They also are more employable and have higher incomes than students who fail to graduate. In 2022, median annual earnings for someone without a high school diploma ($30,788) were 83% of the earnings of a high school graduate ($37,290) and 47% of the earnings of someone with a bachelor’s degree ($64,911)."
  }],
  "h": [{
    "id": "lbw",
    "domainId": "h",
    "name": "Low birth-weight babies",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "1",
    "description": "Birth weight is an important indicator of an infant’s health. Babies born at a low birth weight (less than 5.5 pounds) have a high probability of experiencing developmental problems and short- and long-term disabilities. They also are at greater risk of dying within the first year of life. Infections, multiple births, obesity, poor nutrition, poverty, smoking, stress and violence can increase the chances of a baby being born at a low birth weight. Compared with other affluent countries, the United States has among the highest percentage of babies born at a low birth weight."
  }, {
    "id": "nhi",
    "domainId": "h",
    "name": "Children without health insurance",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "Children with health insurance are more likely to have a regular source of health care they can access for preventive care services and developmental screenings, to treat conditions or to address injuries. Children without coverage are less likely than insured children to receive care when they need it. Having health insurance can protect families from financial crisis when a child experiences a serious or chronic illness and can help kids remain active, healthy and in school ready to learn."
  }, {
    "id": "ctm",
    "domainId": "h",
    "name": "Child and teen deaths per 100,000",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "number",
    "fractionalPartLength": "",
    "description": "The child and teen death rate (deaths per 100,000 children ages 1 to 19) reflects a broad array of factors: physical and mental health; access to health care; community issues; use of safety practices; and, especially for younger children, the level of adult supervision. Accidents, primarily those involving motor vehicles, were the leading cause of death for children and youth, accounting for 28% of all deaths among children ages 1 to 14. As children move further into their teenage years, they encounter new, and potentially deadly, risks. In 2022, accidents, homicides and suicides accounted for 76% of deaths for teens ages 15 to 19."
  }, {
    "id": "oob",
    "domainId": "h",
    "name": "Children and teens ages 10 to 17 who are overweight or obese",
    "baseline": "N.A.",
    "current": "2021–22",
    "currentRace": "2021–22",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "Being overweight or obese during childhood can have harmful effects on a child’s overall health and well-being and can have everlasting impact on their health as adults. (Persons with a Body Mass Index [BMI] between the 85th and 95th percentiles on the Center for Disease Control growth charts are considered to be overweight; those with a BMI at or above the 95th percentile are viewed as obese.) Children who struggle with their weight are at higher risk for a range of health problems, including asthma, heart disease, diabetes and cancer. They are also more likely to experience social and emotional difficulties, such as stigmatization and low self-esteem."
  }],
  "fc": [{
    "id": "spf",
    "domainId": "fc",
    "name": "Children in single-parent families",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "Even with the best efforts of parents, children growing up in single-parent families typically have access to fewer economic resources and valuable time with adults than children in two-parent families in which child-raising responsibilities can be shared. For example, in 2022, 28% of single-parent families had incomes below the poverty line, compared with 6% of married couples with children. The effects of growing up in single-parent families go beyond economics, increasing the likelihood of children dropping out of school, being disconnected from the labor market and becoming teen parents."
  }, {
    "id": "hsd",
    "domainId": "fc",
    "name": "Children in families where the household head lacks a high school diploma",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "Children growing up in households with highly educated adults are better positioned for future success. These parents often are better able to provide the financial stability and security they need to foster their children’s development. Higher levels of parental education also are strongly associated with better outcomes for children, including kids’ own higher educational attainment and achievement. Kids who grow up with parents who have not graduated from high school not only have fewer socioeconomic advantages but also are more likely to be born with a low birth weight, have other health problems, enter school unprepared and have limited educational and employment opportunities as adults."
  }, {
    "id": "hpn",
    "domainId": "fc",
    "name": "Children living in high-poverty areas",
    "baseline": "2013–17",
    "current": "2018–22",
    "currentRace": "2018–22",
    "dataType": "percentage",
    "fractionalPartLength": "",
    "description": "High-poverty neighborhoods — where poverty rates for the total population are 30% or more — come with several challenges that affect the children and families who live there. Residents of these neighborhoods contend with poorer health, higher rates of crime and violence, poor-performing schools due to inadequate funding and limited access to support networks and job opportunities. They also experience higher levels of financial instability. These barriers make it much harder for families to move up the economic ladder. Concentrated neighborhood poverty negatively affects all kids living in the area — not only children in households with low incomes but also those whose parents are economically better off."
  }, {
    "id": "tbr",
    "domainId": "fc",
    "name": "Teen births per 1,000",
    "baseline": "2019",
    "current": "2022",
    "currentRace": "2022",
    "dataType": "number",
    "fractionalPartLength": "",
    "description": "Teenage childbearing can have long-term negative effects for mother and child. Babies born to teens are far more likely to be born preterm and at a low birth weight — and into families with limited educational attainment and economic resources, which undermines their future success. Children born to teen mothers tend to have poorer academic and behavioral outcomes and are more likely to engage in sexual activity and become teen parents themselves. Although the teen birth rate has decreased over the past few years and is currently at a historic low, the teen birth rate in the United States remains the highest among affluent countries."
  }]
};
exports.default = _default;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "states", {
  enumerable: true,
  get: function get() {
    return _locationsMetadata.states;
  }
});
Object.defineProperty(exports, "usa", {
  enumerable: true,
  get: function get() {
    return _locationsMetadata.usa;
  }
});
Object.defineProperty(exports, "regions", {
  enumerable: true,
  get: function get() {
    return _locationsMetadata.regions;
  }
});
exports.isValidLocationId = exports.isState = exports.isRegion = exports.byId = exports.idString = exports.locations = exports.stateDataShape = exports.locationRankShape = exports.locationShape = exports.locationDataShape = exports.locationMetadataShape = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

var _propTypes = require("prop-types");

var _domains = require("./domains.js");

var _locationsMetadata = require("./locationsMetadata.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var locationMetadata = {
  id: _propTypes.string.isRequired,
  abbreviation: _propTypes.string,
  name: _propTypes.string.isRequired,
  dataCenterLocationIdChain: _propTypes.string,
  region: (0, _propTypes.oneOf)(_ramda.default.pluck("id", _locationsMetadata.regions))
};
var locationMetadataShape = (0, _propTypes.shape)(locationMetadata);
exports.locationMetadataShape = locationMetadataShape;
var locationData = {
  id: _propTypes.string.isRequired,
  domains: (0, _propTypes.objectOf)(_domains.domainDataShape)
};
var locationDataShape = (0, _propTypes.shape)(locationData);
exports.locationDataShape = locationDataShape;
var locationShape = (0, _propTypes.shape)(_objectSpread({}, locationMetadata, locationData));
exports.locationShape = locationShape;
var locationRankShape = (0, _propTypes.shape)(_objectSpread({}, locationMetadata, {
  rank: _propTypes.number,
  quartile: _propTypes.number
}));
exports.locationRankShape = locationRankShape;
var stateDataShape = (0, _propTypes.shape)({
  abbreviation: _propTypes.string.isRequired,
  bounds: (0, _propTypes.arrayOf)((0, _propTypes.arrayOf)(_propTypes.number)).isRequired,
  centroid: (0, _propTypes.arrayOf)(_propTypes.number).isRequired,
  // length 2
  d: _propTypes.string.isRequired,
  id: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  quartile: _propTypes.number
});
exports.stateDataShape = stateDataShape;
var locations = [].concat(_toConsumableArray(_locationsMetadata.states), [_locationsMetadata.usa], _toConsumableArray(_locationsMetadata.regions)); // provide the ability to lookup a location by id

exports.locations = locations;

var locationsById = _ramda.default.indexBy(_ramda.default.prop("id"), locations); // if we're given a number, convert it to a FIPS/ANSI compatible string.
// eg 1 -> "01"
// states.topojson.json have number ids
// so use this function when dealting with state features


var idString = function idString(id) {
  return _ramda.default.when(Number.isInteger, function (n) {
    return n.toString().padStart(2, "0");
  }, id);
};

exports.idString = idString;

var byId = function byId(id) {
  return _ramda.default.prop(idString(id), locationsById);
}; // returns true if the given id is a region id


exports.byId = byId;

var isRegion = function isRegion(id) {
  return _ramda.default.includes(id, _ramda.default.pluck("id", _locationsMetadata.regions));
}; // returns true if the given id is a region id


exports.isRegion = isRegion;

var isState = function isState(id) {
  return _ramda.default.includes(id, _ramda.default.pluck("id", _locationsMetadata.states));
};
/**
 * validate the given location Id against the "id" field of locations
 * @param {String} locationId : A locationId to validate
 */


exports.isState = isState;

var isValidLocationId = function isValidLocationId(locationId) {
  return _ramda.default.compose(_ramda.default.includes(locationId), _ramda.default.pluck("id"))(locations);
};

exports.isValidLocationId = isValidLocationId;

},{"./domains.js":6,"./locationsMetadata.js":11,"prop-types":"prop-types","ramda":"ramda"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regions = exports.usa = exports.states = void 0;

/**
 * id for states are FIPS/ANSI state ids
 * useThe: whether or not to use the word "the" in a sentence
 * eg. Education in _the_ United States
 */
var states = [{
  id: "01",
  abbreviation: "AL",
  name: "Alabama",
  region: "3000",
  dataCenterLocationIdChain: "/2/2"
}, {
  id: "02",
  abbreviation: "AK",
  name: "Alaska",
  region: "4000",
  dataCenterLocationIdChain: "/2/3"
}, {
  id: "04",
  abbreviation: "AZ",
  name: "Arizona",
  region: "4000",
  dataCenterLocationIdChain: "/2/4"
}, {
  id: "05",
  abbreviation: "AR",
  name: "Arkansas",
  region: "3000",
  dataCenterLocationIdChain: "/2/5"
}, {
  id: "06",
  abbreviation: "CA",
  name: "California",
  region: "4000",
  dataCenterLocationIdChain: "/2/6"
}, {
  id: "08",
  abbreviation: "CO",
  name: "Colorado",
  region: "4000",
  dataCenterLocationIdChain: "/2/7"
}, {
  id: "09",
  abbreviation: "CT",
  name: "Connecticut",
  region: "1000",
  dataCenterLocationIdChain: "/2/8"
}, {
  id: "10",
  abbreviation: "DE",
  name: "Delaware",
  region: "3000",
  dataCenterLocationIdChain: "/2/9"
}, {
  id: "11",
  abbreviation: "DC",
  name: "District of Columbia",
  region: "3000",
  useThe: true,
  dataCenterLocationIdChain: "/3/10"
}, {
  id: "12",
  abbreviation: "FL",
  name: "Florida",
  region: "3000",
  dataCenterLocationIdChain: "/2/11"
}, {
  id: "13",
  abbreviation: "GA",
  name: "Georgia",
  region: "3000",
  dataCenterLocationIdChain: "/2/12"
}, {
  id: "15",
  abbreviation: "HI",
  name: "Hawaii",
  region: "4000",
  dataCenterLocationIdChain: "/2/13"
}, {
  id: "16",
  abbreviation: "ID",
  name: "Idaho",
  region: "4000",
  dataCenterLocationIdChain: "/2/14"
}, {
  id: "17",
  abbreviation: "IL",
  name: "Illinois",
  region: "2000",
  dataCenterLocationIdChain: "/2/15"
}, {
  id: "18",
  abbreviation: "IN",
  name: "Indiana",
  region: "2000",
  dataCenterLocationIdChain: "/2/16"
}, {
  id: "19",
  abbreviation: "IA",
  name: "Iowa",
  region: "2000",
  dataCenterLocationIdChain: "/2/17"
}, {
  id: "20",
  abbreviation: "KS",
  name: "Kansas",
  region: "2000",
  dataCenterLocationIdChain: "/2/18"
}, {
  id: "21",
  abbreviation: "KY",
  name: "Kentucky",
  region: "3000",
  dataCenterLocationIdChain: "/2/19"
}, {
  id: "22",
  abbreviation: "LA",
  name: "Louisiana",
  region: "3000",
  dataCenterLocationIdChain: "/2/20"
}, {
  id: "23",
  abbreviation: "ME",
  name: "Maine",
  region: "1000",
  dataCenterLocationIdChain: "2/21"
}, {
  id: "24",
  abbreviation: "MD",
  name: "Maryland",
  region: "3000",
  dataCenterLocationIdChain: "/2/22"
}, {
  id: "25",
  abbreviation: "MA",
  name: "Massachusetts",
  region: "1000",
  dataCenterLocationIdChain: "/2/23"
}, {
  id: "26",
  abbreviation: "MI",
  name: "Michigan",
  region: "2000",
  dataCenterLocationIdChain: "/2/24"
}, {
  id: "27",
  abbreviation: "MN",
  name: "Minnesota",
  region: "2000",
  dataCenterLocationIdChain: "/2/25"
}, {
  id: "28",
  abbreviation: "MS",
  name: "Mississippi",
  region: "3000",
  dataCenterLocationIdChain: "/2/26"
}, {
  id: "29",
  abbreviation: "MO",
  name: "Missouri",
  region: "2000",
  dataCenterLocationIdChain: "/2/27"
}, {
  id: "30",
  abbreviation: "MT",
  name: "Montana",
  region: "4000",
  dataCenterLocationIdChain: "/2/28"
}, {
  id: "31",
  abbreviation: "NE",
  name: "Nebraska",
  region: "2000",
  dataCenterLocationIdChain: "/2/29"
}, {
  id: "32",
  abbreviation: "NV",
  name: "Nevada",
  region: "4000",
  dataCenterLocationIdChain: "/2/30"
}, {
  id: "33",
  abbreviation: "NH",
  name: "New Hampshire",
  region: "1000",
  dataCenterLocationIdChain: "/2/31"
}, {
  id: "34",
  abbreviation: "NJ",
  name: "New Jersey",
  region: "1000",
  dataCenterLocationIdChain: "/2/32"
}, {
  id: "35",
  abbreviation: "NM",
  name: "New Mexico",
  region: "4000",
  dataCenterLocationIdChain: "/2/33"
}, {
  id: "36",
  abbreviation: "NY",
  name: "New York",
  region: "1000",
  dataCenterLocationIdChain: "/2/34"
}, {
  id: "37",
  abbreviation: "NC",
  name: "North Carolina",
  region: "3000",
  dataCenterLocationIdChain: "/2/35"
}, {
  id: "38",
  abbreviation: "ND",
  name: "North Dakota",
  region: "2000",
  dataCenterLocationIdChain: "/2/36"
}, {
  id: "39",
  abbreviation: "OH",
  name: "Ohio",
  region: "2000",
  dataCenterLocationIdChain: "/2/37"
}, {
  id: "40",
  abbreviation: "OK",
  name: "Oklahoma",
  region: "3000",
  dataCenterLocationIdChain: "/2/38"
}, {
  id: "41",
  abbreviation: "OR",
  name: "Oregon",
  region: "4000",
  dataCenterLocationIdChain: "/2/39"
}, {
  id: "42",
  abbreviation: "PA",
  name: "Pennsylvania",
  region: "1000",
  dataCenterLocationIdChain: "/2/40"
}, {
  id: "72",
  abbreviation: "PR",
  name: "Puerto Rico",
  dataCenterLocationIdChain: "4/53"
}, {
  id: "44",
  abbreviation: "RI",
  name: "Rhode Island",
  region: "1000",
  dataCenterLocationIdChain: "/2/41"
}, {
  id: "45",
  abbreviation: "SC",
  name: "South Carolina",
  region: "3000",
  dataCenterLocationIdChain: "/2/42"
}, {
  id: "46",
  abbreviation: "SD",
  name: "South Dakota",
  region: "2000",
  dataCenterLocationIdChain: "/2/43"
}, {
  id: "47",
  abbreviation: "TN",
  name: "Tennessee",
  region: "3000",
  dataCenterLocationIdChain: "/2/44"
}, {
  id: "48",
  abbreviation: "TX",
  name: "Texas",
  region: "3000",
  dataCenterLocationIdChain: "/2/45"
}, {
  id: "49",
  abbreviation: "UT",
  name: "Utah",
  region: "4000",
  dataCenterLocationIdChain: "/2/46"
}, {
  id: "50",
  abbreviation: "VT",
  name: "Vermont",
  region: "1000",
  dataCenterLocationIdChain: "/2/47"
}, {
  id: "51",
  abbreviation: "VA",
  name: "Virginia",
  region: "3000",
  dataCenterLocationIdChain: "/2/48"
}, {
  id: "53",
  abbreviation: "WA",
  name: "Washington",
  region: "4000",
  dataCenterLocationIdChain: "/2/49"
}, {
  id: "54",
  abbreviation: "WV",
  name: "West Virginia",
  region: "3000",
  dataCenterLocationIdChain: "/2/50"
}, {
  id: "55",
  abbreviation: "WI",
  name: "Wisconsin",
  region: "2000",
  dataCenterLocationIdChain: "/2/51"
}, {
  id: "56",
  abbreviation: "WY",
  name: "Wyoming",
  region: "4000",
  dataCenterLocationIdChain: "/2/52"
}];
exports.states = states;
var usa = {
  id: "502",
  abbreviation: "USA",
  name: "United States",
  useThe: true,
  dataCenterLocationIdChain: "/1/any"
};
exports.usa = usa;
var regions = [{
  id: "1000",
  name: "Northeast",
  dataCenterLocationIdChain: "/1"
}, {
  id: "2000",
  name: "Midwest",
  dataCenterLocationIdChain: ""
}, {
  id: "3000",
  name: "South",
  dataCenterLocationIdChain: ""
}, {
  id: "4000",
  name: "West",
  dataCenterLocationIdChain: ""
}];
exports.regions = regions;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWindowWidth;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useWindowWidth() {
  var _useState = (0, _react.useState)(window.innerWidth),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  (0, _react.useEffect)(function () {
    var handleResize = function handleResize(e) {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return width;
}

},{"react":"react"}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var S = _interopRequireWildcard(require("./BarChartStyles.js"));

var _ordinalGrowScale = _interopRequireDefault(require("./ordinalGrowScale.js"));

var _d3Scale = require("d3-scale");

var _YLabel = _interopRequireDefault(require("./YLabel.jsx"));

var _useXAxis2 = _interopRequireDefault(require("./useXAxis.js"));

var _useBoundingClientRect = _interopRequireDefault(require("../../lib/useBoundingClientRect.js"));

var _polished = require("polished");

var _propTypes = require("prop-types");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  color: _propTypes.string.isRequired,
  highlightColor: _propTypes.string.isRequired,
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    isHighlighted: _propTypes.bool,
    label: _propTypes.node.isRequired,
    value: _propTypes.any,
    notes: _propTypes.string // markdown

  })),
  customData: (0, _propTypes.shape)({
    maxValue: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
  }),
  formatter: _propTypes.func
};
var defaultProps = {
  data: [],
  formatter: _ramda.default.identity
};

var BarChart = function BarChart(props) {
  var color = props.color,
      data = props.data,
      customData = props.customData,
      formatter = props.formatter,
      highlightColor = props.highlightColor;

  var _useBoundingClientRec = (0, _useBoundingClientRect.default)(),
      _useBoundingClientRec2 = _slicedToArray(_useBoundingClientRec, 2),
      containerRef = _useBoundingClientRec2[0],
      container = _useBoundingClientRec2[1];

  var margin = {
    top: 20,
    right: 20,
    bottom: 20,
    left: 120
  }; // sometimes container.width is undefined or 0.
  // make sure width is always a positive integer or 0

  var width = _ramda.default.compose(_ramda.default.clamp(0, Infinity), function (width) {
    return width - margin.left - margin.right;
  }, _ramda.default.propOr(0, "width"))(container);

  var maxValue = _ramda.default.compose(function (values) {
    return Math.max.apply(Math, _toConsumableArray(values));
  }, _ramda.default.filter(_ramda.default.is(Number))
  /* string are valid, but not to calc the max */
  , _ramda.default.pluck("value"))(data);

  var hasCustomMaxValue = customData && _ramda.default.is(Number, customData.maxValue) && customData.maxValue >= maxValue;

  if (hasCustomMaxValue) {
    maxValue = customData.maxValue;
  }

  var xScale = (0, _d3Scale.scaleLinear)().range([0, width]).domain([0, maxValue]);

  if (!hasCustomMaxValue) {
    xScale = xScale.nice(5);
  }

  var yScale = (0, _ordinalGrowScale.default)().bandwidth(64).domain(_ramda.default.pluck("label", data));
  var height = yScale.totalRange() + margin.top + margin.bottom;
  var barHeight = 40;
  var yBarCenterOffset = (yScale.bandwidth() - barHeight) / 2;

  var _useXAxis = (0, _useXAxis2.default)({
    xScale: xScale,
    height: height,
    width: width,
    margin: margin,
    formatX: formatter,
    data: data
  }),
      xAxisRef = _useXAxis.xAxisRef,
      svgRef = _useXAxis.svgRef;

  return _react.default.createElement(S.Container, {
    ref: containerRef
  }, containerRef.current && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("svg", {
    width: container.width,
    ref: svgRef
  }, _react.default.createElement("g", {
    className: "x-axis",
    ref: xAxisRef
  }), _react.default.createElement("g", {
    transform: "translate(".concat(margin.left, ", ").concat(margin.top, ")")
  }, data.map(function (d, i) {
    // magic number estimating the width of the text
    var textOnBar = width - xScale(d.value) < 35;
    var textPadding = textOnBar ? -5 : 5;
    var textAnchor = textOnBar ? "end" : "start";
    var barColor = d.isHighlighted ? highlightColor : color;
    var textColor = textOnBar ? (0, _polished.readableColor)(barColor) : "black";
    return _react.default.createElement(_react.default.Fragment, {
      key: i
    }, xScale(d.value) && _react.default.createElement("rect", {
      x: 0,
      y: yScale(d.label) + yBarCenterOffset,
      height: barHeight,
      width: xScale(d.value),
      fill: barColor
    }), _react.default.createElement("text", {
      x: (xScale(d.value) || 0) + textPadding,
      y: yScale(d.label) + yScale.bandwidth() / 2,
      alignmentBaseline: "central",
      textAnchor: textAnchor,
      fill: textColor,
      fontSize: 14
    }, _ramda.default.when(_ramda.default.is(Number), function () {
      return formatter(d.value);
    }, d.value)));
  }))), _react.default.createElement(S.YAxis, null, data.map(function (d, i) {
    return _react.default.createElement(_YLabel.default // label could be a react node (Object), in that case, use i
    // https://medium.com/@robinpokorny/index-as-a-key-is-an-anti-pattern-e0349aece318
    , {
      key: _ramda.default.when(_ramda.default.is(Object), function () {
        return i;
      }, d.label),
      style: {
        top: yScale(d.label) + margin.top,
        width: margin.left,
        height: yScale.bandwidth() // fontWeight: d.isHighlighted ? "bold" : "normal"

      },
      margin: margin.left,
      height: yScale.bandwidth(),
      label: d.label,
      notes: d.notes
    });
  }))));
};

BarChart.propTypes = propTypes;
BarChart.defaultProps = defaultProps;
var _default = BarChart;
exports.default = _default;

},{"../../lib/useBoundingClientRect.js":49,"./BarChartStyles.js":14,"./YLabel.jsx":16,"./ordinalGrowScale.js":18,"./useXAxis.js":19,"d3-scale":"d3-scale","polished":"polished","prop-types":"prop-types","ramda":"ramda","react":"react"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YAxis = exports.XAxisG = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "BarChartStyles__Container",
  componentId: "vro6t9-0"
})(["position:relative;display:block;min-width:0;rect{transition:all 250ms;}svg{overflow:visible;}.x-axis .tick + .tick line{display:none;}"]);

exports.Container = Container;

var XAxisG = _styledComponents.default.g.withConfig({
  displayName: "BarChartStyles__XAxisG",
  componentId: "vro6t9-1"
})(["font-size:10px;"]);

exports.XAxisG = XAxisG;

var YAxis = _styledComponents.default.div.withConfig({
  displayName: "BarChartStyles__YAxis",
  componentId: "vro6t9-2"
})(["position:absolute;left:0;top:0;"]);

exports.YAxis = YAxis;

},{"styled-components":"styled-components"}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Svg = _styledComponents.default.svg.withConfig({
  displayName: "InfoIcon__Svg",
  componentId: "sc-1jpqd6r-0"
})(["margin-left:6px;"]); // https://feathericons.com/


var InfoIcon = function InfoIcon(props) {
  return _react.default.createElement(Svg, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-info"
  }, _react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), _react.default.createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "12"
  }), _react.default.createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "8"
  }));
};

var _default = InfoIcon;
exports.default = _default;

},{"react":"react","styled-components":"styled-components"}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var S = _interopRequireWildcard(require("./YLabelStyles.js"));

var _Popup = _interopRequireDefault(require("../Popup/Popup.jsx"));

var _marked = _interopRequireDefault(require("marked"));

var _InfoIcon = _interopRequireDefault(require("./InfoIcon.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  label: _propTypes.node.isRequired,
  margin: _propTypes.number.isRequired,
  height: _propTypes.number.isRequired,
  notes: _propTypes.string // markdown

};

var YLabel = function YLabel(props) {
  var height = props.height,
      label = props.label,
      margin = props.margin,
      notes = props.notes,
      rest = _objectWithoutProperties(props, ["height", "label", "margin", "notes"]);

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      isHidden = _useState2[0],
      setIsHidden = _useState2[1];

  return _react.default.createElement(S.Container, _extends({}, rest, {
    onMouseEnter: function onMouseEnter() {
      return setIsHidden(false);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHidden(true);
    }
  }), _react.default.createElement(S.YLabel, {
    hasNotes: !!notes
  }, _react.default.createElement(S.Label, null, label), notes && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_InfoIcon.default, null), _react.default.createElement(_Popup.default, {
    isHidden: isHidden,
    top: height / 2,
    left: margin / 2,
    width: margin * 2,
    triangleSide: "left",
    offset: margin / 2
  }, _react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, _marked.default)(notes)
    }
  })))));
};

YLabel.propTypes = propTypes;
var _default = YLabel;
exports.default = _default;

},{"../Popup/Popup.jsx":39,"./InfoIcon.jsx":15,"./YLabelStyles.js":17,"marked":"marked","prop-types":"prop-types","react":"react"}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.YLabel = exports.Container = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Container = _styledComponents.default.div.withConfig({
  displayName: "YLabelStyles__Container",
  componentId: "wv10fk-0"
})(["position:absolute;left:0;display:flex;align-items:center;justify-content:flex-end;box-sizing:border-box;padding-right:10px;font-size:14px;line-height:1.2;text-align:right;"]);

exports.Container = Container;

var YLabel = _styledComponents.default.div.withConfig({
  displayName: "YLabelStyles__YLabel",
  componentId: "wv10fk-1"
})(["display:flex;align-items:center;", ""], function (props) {
  return props.hasNotes && (0, _styledComponents.css)(["cursor:default;"]);
});

exports.YLabel = YLabel;
var labelFontSize = 14;

var Label = _styledComponents.default.div.withConfig({
  displayName: "YLabelStyles__Label",
  componentId: "wv10fk-2"
})(["font-size:", "px;"], labelFontSize);

exports.Label = Label;

},{"styled-components":"styled-components"}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ordinalGrowScale;

// a scale for d3 that takes in the bandwidth and the domain
// will calculate the svg plot height based on these
// example scale: https://github.com/d3/d3-scale/blob/master/src/ordinal.js
function ordinalGrowScale() {
  var domain = [];
  var bandwidth = 0;
  var padding = 0;
  var paddingOuter = 0;

  function scale(x) {
    // find the index of the given domain
    var i = domain.findIndex(function (d) {
      return d === x;
    }); // if it's not found in the domain, just return the first one

    if (i === -1) {
      i = 0;
    } // see diagram: https://github.com/d3/d3-scale#band-scales


    var step = bandwidth + padding;
    var value = paddingOuter + step * i;

    if (isNaN(value)) {
      throw new Error("ordinalGrowScale value is NaN:", x);
    }

    return value;
  } // get or set the bandwidth


  scale.bandwidth = function (_bandwidth, _padding, _paddingOuter) {
    if (arguments.length === 0) {
      return bandwidth;
    }

    if (arguments.length < 2) {
      _padding = 0;
    }

    if (arguments.length < 3) {
      _paddingOuter = _padding;
    }

    bandwidth = _bandwidth;
    padding = _padding;
    paddingOuter = _paddingOuter;
    return this;
  }; // get or set the domain


  scale.domain = function (values) {
    if (arguments.length === 0) {
      return domain;
    } else if (arguments.length === 1) {
      if (!Array.isArray(values)) {
        throw new Error("domain must be an array");
      }

      domain = values;
    }

    return this;
  }; // get the total height, based on the domain and the bandwidth
  // see diagram: https://github.com/mbostock/d3/wiki/Ordinal-Scales


  scale.totalRange = function () {
    return paddingOuter * 2 + bandwidth * domain.length + padding * (domain.length - 1);
  };

  return scale;
}

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useXAxis;

var _react = require("react");

var _d3Axis = require("d3-axis");

var _d3Selection = require("d3-selection");

require("d3-transition");

var DURATION = 250;

function useXAxis(_ref) {
  var xScale = _ref.xScale,
      height = _ref.height,
      width = _ref.width,
      margin = _ref.margin,
      formatX = _ref.formatX,
      data = _ref.data;
  var xAxisRef = (0, _react.useRef)();
  var svgRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    // transition the svg height.  We're using d3-transition for this
    // so the transition is in sync with the x-axis transition.
    // (css transitions are not in sync)
    (0, _d3Selection.select)(svgRef.current).transition().duration(DURATION).attr("height", height);
    var xAxis = (0, _d3Axis.axisBottom)().scale(xScale).ticks(6).tickFormat(formatX).tickSizeOuter(0);
    var xAxisG = (0, _d3Selection.select)(xAxisRef.current);
    xAxisG.transition().duration(DURATION).attr("transform", "translate(".concat(margin.left, ", ").concat(height - margin.bottom, ")")).call(xAxis);
    var ticks = xAxisG.selectAll(".tick line"); // the very dumb way to add a cirlce if it's exists

    var circle = ticks.selectAll("circle").data([0]);
    circle.enter().append("circle").style("fill", "#333").attr("r", 3);
    ticks.enter().merge(ticks).transition().duration(DURATION).attr("y1", 0 - height + margin.top + margin.bottom).attr("y2", 0).attr("stroke", "#ddd");
  }, [width, data, height, xScale, formatX, margin.left, margin.bottom, margin.top]);
  return {
    xAxisRef: xAxisRef,
    svgRef: svgRef
  };
}

},{"d3-axis":"d3-axis","d3-selection":"d3-selection","d3-transition":"d3-transition","react":"react"}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _propTypes = require("prop-types");

var _domains = require("../../common/domains.js");

var S = _interopRequireWildcard(require("./DomainSelectorStyles.js"));

var _Select = _interopRequireDefault(require("../Select/Select.jsx"));

var _useWindowWidth = _interopRequireDefault(require("../../common/useWindowWidth.js"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  selectedDomain: _domains.domainMetadataShape.isRequired,
  onDomainClick: _propTypes.func.isRequired
};

var DomainSelector = function DomainSelector(props) {
  var selectedDomain = props.selectedDomain,
      onDomainClick = props.onDomainClick;
  var windowWidth = (0, _useWindowWidth.default)();
  return _react.default.createElement("div", null, windowWidth <= 992 ? _react.default.createElement(_Select.default, {
    selectProps: {
      items: _domains.domains,
      itemToString: R.prop("name"),
      selectedItem: selectedDomain,
      onSelectedItemChange: function onSelectedItemChange(changes) {
        if (!R.eqBy(R.prop("id"), changes.selectedItem, selectedDomain)) {
          onDomainClick(changes.selectedItem);
        }
      } // isOpen: true,

    }
  }) : _react.default.createElement(S.Container, null, _domains.domains.map(function (d) {
    return _react.default.createElement(S.Domain, {
      key: d.name,
      domain: d,
      active: d === selectedDomain,
      onClick: function onClick() {
        return onDomainClick(d);
      }
    }, d.name);
  })));
};

DomainSelector.propTypes = propTypes;
var _default = DomainSelector;
exports.default = _default;

},{"../../common/domains.js":6,"../../common/useWindowWidth.js":12,"../Select/Select.jsx":45,"./DomainSelectorStyles.js":21,"prop-types":"prop-types","ramda":"ramda","react":"react"}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Domain = exports.Container = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Container = _styledComponents.default.div.withConfig({
  displayName: "DomainSelectorStyles__Container",
  componentId: "sc-1wb0adk-0"
})(["display:flex;padding:0;width:100%;align-items:initial;justify-content:flex-start;justify-items:center;align-content:center;border-bottom:1px solid #606060;flex-wrap:wrap;& > *{flex:none;}"]);

exports.Container = Container;

var Domain = _styledComponents.default.button.attrs({
  type: "button"
}).withConfig({
  displayName: "DomainSelectorStyles__Domain",
  componentId: "sc-1wb0adk-1"
})(["display:flex;align-items:center;justify-content:center;position:relative;box-sizing:border-box;z-index:0;letter-spacing:0.67px;line-height:1;background:none;border:0;cursor:pointer;border:1px solid #606060;border-bottom:0;border-top-left-radius:10px;border-top-right-radius:10px;text-align:center;background-color:#f1eee6;font-weight:bold;width:auto;font-size:min(max(14px,calc(9px + 0.46vw)),20px);margin:0 1.2%;padding:18px 1.2%;@media (max-width:480px){font-size:11px;}", ";"], function (props) {
  return props.active ? (0, _styledComponents.css)(["color:black;outline:none;@media (min-width:992px){background-color:white;}&::before{height:4px;content:\"\";position:absolute;bottom:-1px;width:100%;background:#ffffff;z-index:999999;display:block;@media (max-width:992px){display:none;}}"]) : (0, _styledComponents.css)(["color:black;&::before{height:4px;background-color:#ccc;}&:active,&:focus,&:hover{outline:none;&::before{height:8px;background-color:", ";}}"], function (props) {
    return props.domain.color;
  });
});

exports.Domain = Domain;

},{"styled-components":"styled-components"}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreDataLink = exports.MoreDataLinkContainer = exports.HeaderLink = exports.Header = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = require("../../styles/color.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var containerGap = 48;
var containerColumn = "calc(50% - ".concat(containerGap / 2, "px)");

var Container = _styledComponents.default.div.withConfig({
  displayName: "CommonStyles__Container",
  componentId: "t3cfjf-0"
})(["display:grid;grid-gap:", "px;grid-template-columns:", " ", ";@media (max-width:1000px){display:block;}"], containerGap, containerColumn, containerColumn);

exports.Container = Container;

var Header = _styledComponents.default.h2.withConfig({
  displayName: "CommonStyles__Header",
  componentId: "t3cfjf-1"
})(["display:flex;align-items:center;min-height:2.6em;color:", ";font-size:20px;font-weight:700;line-height:1.33;text-transform:uppercase;"], _color.caseyGrey);

exports.Header = Header;

var HeaderLink = _styledComponents.default.a.attrs({
  target: "_blank"
}).withConfig({
  displayName: "CommonStyles__HeaderLink",
  componentId: "t3cfjf-2"
})(["color:#000;text-decoration:none;cursor:pointer;&:active,&:focus,&:hover{text-decoration:underline;}&:visited:{color:#000;}"]);

exports.HeaderLink = HeaderLink;

var MoreDataLinkContainer = _styledComponents.default.div.withConfig({
  displayName: "CommonStyles__MoreDataLinkContainer",
  componentId: "t3cfjf-3"
})(["margin:0 auto;margin-top:40px;text-align:center;@media (min-width:900px){display:flex;align-items:center;width:50%;}"]);

exports.MoreDataLinkContainer = MoreDataLinkContainer;

var MoreDataLink = _styledComponents.default.a.withConfig({
  displayName: "CommonStyles__MoreDataLink",
  componentId: "t3cfjf-4"
})(["display:block;margin:0 auto;padding:1em 1.5em;color:#000;text-align:center;text-decoration:none;background-color:", ";border-radius:25px;"], (0, _color.quartileColor)("overall", 0));

exports.MoreDataLink = MoreDataLink;

},{"../../styles/color.js":51,"styled-components":"styled-components"}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _propTypes = require("prop-types");

var CS = _interopRequireWildcard(require("./CommonStyles.js"));

var S = _interopRequireWildcard(require("./DomainStyles.js"));

var _domains = require("../../common/domains.js");

var _locations = require("../../common/locations.js");

var _dataTypes = require("../../common/dataTypes.js");

var _compareBy = require("../../common/compareBy.js");

var _BarChart = _interopRequireDefault(require("../BarChart/BarChart.jsx"));

var _AppStateContext = require("../../lib/AppStateContext.jsx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propTypes = {
  domain: _domains.domainMetadataShape.isRequired,
  location: _locations.locationShape.isRequired,
  regionData: (0, _propTypes.arrayOf)(_locations.locationShape).isRequired // used for region

};

var isNilOrEmpty = _ramda.default.anyPass([_ramda.default.isNil, _ramda.default.isEmpty]);

var getIndicatorTitleLink = function getIndicatorTitleLink(label, indicatorID, locationIdChain) {
  if (isNilOrEmpty(indicatorID)) return label;
  return _react.default.createElement(CS.HeaderLink, {
    href: "https://datacenter.aecf.org/data/tables/" + indicatorID + (!isNilOrEmpty(locationIdChain) ? "#detailed" + locationIdChain + "/false/any/any/any" : "")
  }, label);
};

var getDataFor = function getDataFor(compareById, location, domain, indicator, regionData) {
  var path = ["domains", domain.id, "indicators", indicator.id];

  var thisIndicator = _ramda.default.path(path, location);

  switch (compareById) {
    case "change":
      {
        return [{
          label: getIndicatorTitleLink(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", null, location.name), _react.default.createElement("div", null, indicator.current)), indicator.dataCenterIndicatorID, location.dataCenterLocationIdChain),
          value: thisIndicator.currentValue,
          notes: thisIndicator.currentValue === "N.A." ? "Data not available." : ""
        }, {
          label: getIndicatorTitleLink(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", null, location.name), _react.default.createElement("div", null, indicator.baseline)), indicator.dataCenterIndicatorID, location.dataCenterLocationIdChain),
          value: thisIndicator.baselineValue,
          notes: thisIndicator.baselineValue === "N.A." ? "Data not available." : ""
        }];
      }

    case "race":
      {
        var raceData = _ramda.default.prop("raceData", thisIndicator);

        return raceData.sort(function (a, b) {
          var labelA = a.label.toLowerCase();
          var labelB = b.label.toLowerCase();

          if (labelA === "total" || labelB === "national average") {
            return 1;
          }

          if (labelB === "total" || labelA === "national average") {
            return -1;
          }

          if (labelA > labelB) {
            return 1;
          }

          if (labelA < labelB) {
            return -1;
          }

          return 0;
        }).map(function (race) {
          return _objectSpread({}, race, {
            label: getIndicatorTitleLink(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", null, race.label)), indicator.dataCenterRaceIndicatorID, location.dataCenterLocationIdChain)
          });
        });
      }

    case "region":
      {
        // either the region for this state, or all the regions if usa is selected
        var displayedRegions = location.id === _locations.usa.id ? _ramda.default.pluck("id", _locations.regions) : [location.region];

        var statesInRegion = function statesInRegion(region) {
          return _ramda.default.compose(_ramda.default.join("  \n"), // markdown for new line ends with 2 spaces
          _ramda.default.map(_ramda.default.when(_ramda.default.equals(location.name), function (name) {
            return "**".concat(name, "**");
          })), // bold selected state
          _ramda.default.pluck("name"), _ramda.default.filter(_ramda.default.propEq("region", region.id)))(_locations.states);
        };

        return _ramda.default.compose( // if we're looking at a state, add it to the end
        _ramda.default.when(function () {
          return location.id !== _locations.usa.id;
        }, _ramda.default.append({
          label: getIndicatorTitleLink(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", null, location.name)), indicator.dataCenterIndicatorID, location.dataCenterLocationIdChain),
          value: thisIndicator.currentValue,
          isHighlighted: true,
          notes: thisIndicator.currentValue === "N.A." ? "Data not available." : ""
        })), _ramda.default.map(function (regionOrUs) {
          return {
            // show states in the region in the tooltip
            notes: (0, _locations.isRegion)(regionOrUs.id) ? statesInRegion(regionOrUs) : undefined,
            label: (0, _locations.isRegion)(regionOrUs.id) ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", null, regionOrUs.name)) : getIndicatorTitleLink(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", null, regionOrUs.name)), indicator.dataCenterIndicatorID, regionOrUs.dataCenterLocationIdChain),
            value: _ramda.default.compose(_ramda.default.prop("currentValue"), _ramda.default.path(path))(regionOrUs),
            isHighlighted: regionOrUs.id === location.id // highlight united states

          };
        }), // usa and the region for this state
        // or, usa and all the regions
        _ramda.default.filter(function (region) {
          return _ramda.default.includes(region.id, displayedRegions) || region.id === _locations.usa.id;
        }))(regionData);
      }

    default:
      return [];
  }
};

var Domain = function Domain(props) {
  var domain = props.domain,
      location = props.location,
      regionData = props.regionData;

  var _useContext = (0, _react.useContext)(_AppStateContext.AppStateContext),
      selectedCompareById = _useContext.appState.selectedCompareById,
      setCompareById = _useContext.actions.setCompareById,
      dispatch = _useContext.dispatch;

  var compareByOptionsJsx = _ramda.default.compose(function (arr) {
    return arr.map(function (jsx, i) {
      return _ramda.default.when(_ramda.default.propSatisfies(_ramda.default.isNil, "key"), _ramda.default.assoc("key", "divider-".concat(i)), jsx);
    });
  }, _ramda.default.intersperse(_react.default.createElement(S.CompareByDivider, null)), _ramda.default.map(function (option) {
    return _react.default.createElement(S.CompareByButton, {
      key: option.id,
      isSelected: selectedCompareById === option.id,
      onClick: function onClick() {
        return dispatch(setCompareById(option.id));
      }
    }, option.label);
  }))(_compareBy.compareByOptions);

  return _react.default.createElement("div", null, _react.default.createElement(S.CompareContainer, null, _react.default.createElement(S.CompareText, null, "Compare by: "), _react.default.createElement(S.CompareByOptions, null, compareByOptionsJsx)), _react.default.createElement(CS.Container, null, domain.indicators.map(function (indicator) {
    var data = getDataFor(selectedCompareById, location, domain, indicator, regionData);

    var barChartCustomData = _ramda.default.path(["domains", domain.id, "indicators", indicator.id], location).barChartCustomData;

    var formatter = (0, _dataTypes.getFormatter)(indicator.dataType, indicator.fractionalPartLength);
    var indicatorTitle = indicator.name;
    var indicatorId = indicator.dataCenterIndicatorID;

    if (selectedCompareById === "race") {
      indicatorId = indicator.dataCenterRaceIndicatorID;

      if (!isNilOrEmpty(indicator.currentRace)) {
        indicatorTitle += " (".concat(indicator.currentRace, ")");
      }
    } else if (selectedCompareById === "region") {
      if (!isNilOrEmpty(indicator.current)) {
        indicatorTitle += " (".concat(indicator.current, ")");
      }
    }

    return _react.default.createElement("div", {
      key: indicator.id
    }, _react.default.createElement(CS.Header, null, getIndicatorTitleLink(indicatorTitle, indicatorId)), isNilOrEmpty(indicator.description) ? "" : _react.default.createElement("p", null, indicator.description), _react.default.createElement(_BarChart.default, {
      color: domain.color,
      highlightColor: domain.quartileColors[0],
      data: data,
      customData: barChartCustomData && _ramda.default.find(_ramda.default.propEq("compareBy", selectedCompareById), barChartCustomData),
      formatter: formatter,
      domain: indicator.domain
    }));
  })), _react.default.createElement(CS.MoreDataLinkContainer, null, _react.default.createElement(CS.MoreDataLink, {
    href: "https://datacenter.aecf.org/data#" + location.abbreviation,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Find More ", location.name, " Data on the KIDS COUNT Data Center")));
};

Domain.propTypes = propTypes;
var _default = Domain;
exports.default = _default;

},{"../../common/compareBy.js":4,"../../common/dataTypes.js":5,"../../common/domains.js":6,"../../common/locations.js":10,"../../lib/AppStateContext.jsx":48,"../BarChart/BarChart.jsx":13,"./CommonStyles.js":22,"./DomainStyles.js":24,"prop-types":"prop-types","ramda":"ramda","react":"react"}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareByOptions = exports.CompareText = exports.CompareByDivider = exports.CompareByButton = exports.CompareContainer = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = require("../../styles/color.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "DomainStyles__Container",
  componentId: "kbowfm-0"
})([""]);

exports.Container = Container;

var CompareContainer = _styledComponents.default.div.withConfig({
  displayName: "DomainStyles__CompareContainer",
  componentId: "kbowfm-1"
})(["margin-bottom:10px;text-align:center;"]);

exports.CompareContainer = CompareContainer;

var CompareByButton = _styledComponents.default.button.attrs({
  type: "button"
}).withConfig({
  displayName: "DomainStyles__CompareByButton",
  componentId: "kbowfm-2"
})(["position:relative;margin:0 10px;color:", ";font-size:21px;font-weight:", ";text-decoration:", ";background:none;border:none;cursor:pointer;"], function (props) {
  return props.isSelected ? "#000" : "${caseyGrey}";
}, function (props) {
  return props.isSelected ? "normal" : 300;
}, function (props) {
  return props.isSelected ? "underline" : "none";
});

exports.CompareByButton = CompareByButton;

var CompareByDivider = _styledComponents.default.span.withConfig({
  displayName: "DomainStyles__CompareByDivider",
  componentId: "kbowfm-3"
})(["color:", ";font-size:21px;font-weight:300;&::after{content:\"/\";}"], _color.caseyGrey);

exports.CompareByDivider = CompareByDivider;

var CompareText = _styledComponents.default.span.withConfig({
  displayName: "DomainStyles__CompareText",
  componentId: "kbowfm-4"
})(["color:", ";font-size:21px;font-weight:700;text-transform:uppercase;"], _color.caseyGrey);

exports.CompareText = CompareText;

var CompareByOptions = _styledComponents.default.span.withConfig({
  displayName: "DomainStyles__CompareByOptions",
  componentId: "kbowfm-5"
})(["display:inline-block;"]);

exports.CompareByOptions = CompareByOptions;

},{"../../styles/color.js":51,"styled-components":"styled-components"}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var S = _interopRequireWildcard(require("./IndicatorOverviewStyles.js"));

var CS = _interopRequireWildcard(require("./CommonStyles.js"));

var _locations = require("../../common/locations.js");

var _indicators = require("../../common/indicators.js");

var _dataTypes = require("../../common/dataTypes.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  indicatorMetadata: _indicators.indicatorMetadataShape.isRequired,
  indicatorData: _indicators.indicatorDataShape.isRequired,
  location: _locations.locationMetadataShape.isRequired
};

var IndicatorOverview = function IndicatorOverview(props) {
  var indicatorMetadata = props.indicatorMetadata,
      indicatorData = props.indicatorData,
      location = props.location;
  var formatter = (0, _dataTypes.getFormatter)(indicatorMetadata.dataType, indicatorMetadata.fractionalPartLength);

  var valueIsNA = function valueIsNA(value) {
    return value.toString().toLowerCase() === "n.a.";
  };

  var getValue = function getValue(value) {
    return !_ramda.default.is(Number, value) ? value : formatter(value);
  };

  return _react.default.createElement(S.Container, null, _react.default.createElement(S.Top, null, _react.default.createElement(S.Name, null, _ramda.default.isNil(indicatorMetadata.dataCenterIndicatorID) || indicatorMetadata.dataCenterIndicatorID === "" ? indicatorMetadata.name : _react.default.createElement(CS.HeaderLink, {
    href: "https://datacenter.aecf.org/data/tables/" + indicatorMetadata.dataCenterIndicatorID
  }, indicatorMetadata.name), _react.default.createElement(S.Raw, null, "Total in ", location.abbreviation, ":", " ", _ramda.default.when(_ramda.default.is(Number), _dataTypes.numberFormatter, indicatorData.rawValue))), _react.default.createElement(S.Box, {
    valueIsNA: valueIsNA(indicatorData.baselineValue)
  }, _react.default.createElement(S.Value, null, getValue(indicatorData.baselineValue)), _react.default.createElement(S.Label, null, indicatorMetadata.baseline)), _react.default.createElement(S.Box, {
    current: true,
    valueIsNA: valueIsNA(indicatorData.currentValue)
  }, _react.default.createElement(S.Change, {
    change: indicatorData.change
  }, indicatorData.change.toLowerCase() === "n.a." ? "" : indicatorData.change), _react.default.createElement(S.Value, null, getValue(indicatorData.currentValue)), _react.default.createElement(S.Label, null, indicatorMetadata.current))));
};

IndicatorOverview.propTypes = propTypes;
var _default = IndicatorOverview;
exports.default = _default;

},{"../../common/dataTypes.js":5,"../../common/indicators.js":8,"../../common/locations.js":10,"./CommonStyles.js":22,"./IndicatorOverviewStyles.js":26,"ramda":"ramda","react":"react"}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = exports.Label = exports.Value = exports.Change = exports.Name = exports.Raw = exports.Top = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _color = require("../../styles/color.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "IndicatorOverviewStyles__Container",
  componentId: "xyl01p-0"
})(["& + &{margin-top:30px;}"]);

exports.Container = Container;

var Top = _styledComponents.default.div.withConfig({
  displayName: "IndicatorOverviewStyles__Top",
  componentId: "xyl01p-1"
})(["display:flex;align-items:center;"]);

exports.Top = Top;

var Raw = _styledComponents.default.div.withConfig({
  displayName: "IndicatorOverviewStyles__Raw",
  componentId: "xyl01p-2"
})(["padding:10px 0;color:", ";font-size:15px;font-weight:300;letter-spacing:0.6px;text-align:left;"], _color.caseyGrey);

exports.Raw = Raw;

var Name = _styledComponents.default.div.withConfig({
  displayName: "IndicatorOverviewStyles__Name",
  componentId: "xyl01p-3"
})(["flex:auto;color:", ";font-size:20px;font-weight:300;line-height:1.25;"], _color.caseyGrey);

exports.Name = Name;
var changeColors = {
  better: "#417505",
  same: "#f8e71c",
  worse: "#c8102e"
};

var Change = _styledComponents.default.div.withConfig({
  displayName: "IndicatorOverviewStyles__Change",
  componentId: "xyl01p-4"
})(["padding:4px;color:", ";font-size:15px;letter-spacing:0.5px;text-align:center;background-color:", ";"], function (props) {
  return (0, _polished.readableColor)(changeColors[props.change] || "#fff");
}, function (props) {
  return changeColors[props.change];
});

exports.Change = Change;

var Value = _styledComponents.default.div.withConfig({
  displayName: "IndicatorOverviewStyles__Value",
  componentId: "xyl01p-5"
})([""]);

exports.Value = Value;

var Label = _styledComponents.default.div.withConfig({
  displayName: "IndicatorOverviewStyles__Label",
  componentId: "xyl01p-6"
})([""]);

exports.Label = Label;

var Box = _styledComponents.default.div.withConfig({
  displayName: "IndicatorOverviewStyles__Box",
  componentId: "xyl01p-7"
})(["display:flex;flex:none;flex-direction:column;align-self:flex-end;min-width:100px;margin-left:10px;", "{padding:0 10px 4px;color:#757575;font-size:15px;font-weight:", ";letter-spacing:0.5px;text-align:center;}", "{padding:10px 12px;color:", ";font-weight:", ";font-size:", "px;line-height:52px;text-align:center;}"], Label, function (props) {
  return props.current ? "normal" : 300;
}, Value, function (props) {
  return props.current ? "#363636" : "#757575";
}, function (props) {
  return !props.current || props.valueIsNA ? 300 : 700;
}, function (props) {
  return props.valueIsNA ? 18 : props.current ? 30 : 20;
});

exports.Box = Box;

},{"../../styles/color.js":51,"polished":"polished","styled-components":"styled-components"}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _propTypes = require("prop-types");

var CS = _interopRequireWildcard(require("./CommonStyles.js"));

var _domains = require("../../common/domains.js");

var _locations = require("../../common/locations.js");

var _IndicatorOverview = _interopRequireDefault(require("./IndicatorOverview.jsx"));

var _RankHeader = _interopRequireDefault(require("../RankHeader/RankHeader.jsx"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  onDomainClick: _propTypes.func,
  location: _locations.locationShape
};

var otherDomains = _domains.domains.filter(function (d) {
  return d.id !== "overall";
});

var Overall = function Overall(props) {
  var location = props.location,
      onDomainClick = props.onDomainClick;
  return _react.default.createElement("div", null, _react.default.createElement(CS.Container, null, otherDomains.map(function (domain) {
    return _react.default.createElement("div", {
      key: domain.id
    }, _react.default.createElement(_RankHeader.default, {
      color: domain.color,
      isLink: typeof onDomainClick === "function",
      onClick: function onClick() {
        return onDomainClick && onDomainClick(domain);
      },
      rank: _ramda.default.path(["domains", domain.id, "rank"], location)
    }, domain.name), _react.default.createElement("div", null, domain.indicators.map(function (indicator) {
      return _react.default.createElement(_IndicatorOverview.default, {
        key: indicator.id,
        indicatorMetadata: indicator,
        indicatorData: _ramda.default.path(["domains", domain.id, "indicators", indicator.id], location),
        location: location
      });
    })));
  })), _react.default.createElement(CS.MoreDataLinkContainer, null, _react.default.createElement(CS.MoreDataLink, {
    href: "https://datacenter.aecf.org/data#" + location.abbreviation,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Find More ", location.name, " Data on the KIDS COUNT Data Center")));
};

Overall.propTypes = propTypes;
var _default = Overall;
exports.default = _default;

},{"../../common/domains.js":6,"../../common/locations.js":10,"../RankHeader/RankHeader.jsx":41,"./CommonStyles.js":22,"./IndicatorOverview.jsx":25,"prop-types":"prop-types","ramda":"ramda","react":"react"}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstructionText = _styledComponents.default.div.withConfig({
  displayName: "InstructionText",
  componentId: "tmuv9h-0"
})(["text-align:left;padding:12px 12px 12px 0;font-size:18px;"]);

var _default = InstructionText;
exports.default = _default;

},{"styled-components":"styled-components"}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _propTypes = require("prop-types");

var _locations = require("../../common/locations.js");

var _domains = require("../../common/domains.js");

var _color = require("../../styles/color.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var propTypes = {
  domain: _domains.domainMetadataShape.isRequired,
  hoveredStateId: _propTypes.string,
  isBlurred: _propTypes.bool.isRequired,
  statesData: (0, _propTypes.arrayOf)(_locations.stateDataShape),
  onStateHover: _propTypes.func.isRequired,
  onStateSelect: _propTypes.func.isRequired
};
var boxStates = ["VT", "NH", "MA", "RI", "CT", "NJ", "DE", "MD", "DC", "PR"];
var boxDimensions = {
  width: 48,
  height: 36,
  spacing: 9,
  padding: 10
};
/* <Box
  key={abbreviation}
  isHovered={stateData.id === hoveredStateId}
  onBoxHover={() => onStateHover(stateData.id)}
  onBoxClick={() => onStateSelect(stateData.id)}
  text={abbreviation}
  top={i * (boxDimensions.height + boxDimensions.spacing)}
  fill={fill}
  width={boxDimensions.width}
  height={boxDimensions.height}
/> */

var Svg = _styledComponents.default.svg.withConfig({
  displayName: "Boxes__Svg",
  componentId: "sc-8zco81-0"
})(["position:absolute;right:", ";top:52%;width:5%;transform:translateY(-50%);", ";"], function (props) {
  return props.width >= 960 ? "-30px" : "10px";
}, function (props) {
  return (0, _styledComponents.css)(["opacity:", ";"], props.isBlurred ? "0.1" : "1");
});

var Boxes = function Boxes(props) {
  var domain = props.domain,
      hoveredStateId = props.hoveredStateId,
      isBlurred = props.isBlurred,
      onStateHover = props.onStateHover,
      onStateSelect = props.onStateSelect,
      statesData = props.statesData;
  var fontSize = 20;
  var svgWidth = boxDimensions.width + boxDimensions.padding;
  var svgHeight = boxStates.length * (boxDimensions.height + boxDimensions.spacing) + boxDimensions.padding - boxDimensions.spacing; // the last box doesn't have spacing after it

  return _react.default.createElement(Svg, {
    isBlurred: isBlurred,
    viewBox: "0 0 ".concat(svgWidth, " ").concat(svgHeight),
    width: svgWidth
  }, _react.default.createElement("g", {
    onMouseLeave: function onMouseLeave(e) {
      return onStateHover();
    }
  }, boxStates.map(function (abbreviation, i) {
    var height = boxDimensions.height,
        width = boxDimensions.width,
        spacing = boxDimensions.spacing,
        padding = boxDimensions.padding;
    var top = i * (height + spacing);
    var stateData = R.find(R.propEq("abbreviation", abbreviation), statesData);
    var fill = R.compose((0, _color.quartileColor)(domain.id), R.prop("quartile"))(stateData);
    var isHovered = stateData.id === hoveredStateId;
    var stroke = isHovered ? (0, _polished.darken)(0.1, fill) : "rgba(0, 0, 0, 0.001)";
    return _react.default.createElement("g", {
      key: abbreviation,
      transform: "translate(".concat(padding / 2, ", ").concat(top + padding / 2, ")"),
      onMouseEnter: function onMouseEnter(e) {
        return onStateHover(stateData.id);
      },
      onClick: function onClick(e) {
        return onStateSelect(stateData.id);
      }
    }, _react.default.createElement("rect", {
      className: "state-box__background",
      width: width,
      height: height,
      fill: fill,
      stroke: stroke,
      strokeWidth: "3",
      style: {
        cursor: "pointer",
        transition: "fill 0.25s"
      }
    }), _react.default.createElement("text", {
      className: "state-box__label",
      x: width / 2,
      y: height / 2 + fontSize * 0.35,
      style: {
        fill: (0, _polished.readableColor)(fill),
        fontSize: fontSize,
        textAnchor: "middle",
        cursor: "pointer"
      }
    }, abbreviation));
  })));
};

Boxes.propTypes = propTypes;
var _default = Boxes;
exports.default = _default;

},{"../../common/domains.js":6,"../../common/locations.js":10,"../../styles/color.js":51,"polished":"polished","prop-types":"prop-types","ramda":"ramda","react":"react","styled-components":"styled-components"}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _color = require("../../styles/color.js");

var S = _interopRequireWildcard(require("./ChoroplethMapStyles.js"));

var _propTypes = require("prop-types");

var _domains = require("../../common/domains.js");

var _locations = require("../../common/locations.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  domain: _domains.domainMetadataShape.isRequired,
  isBlurred: _propTypes.bool,
  statesData: (0, _propTypes.arrayOf)(_locations.stateDataShape),
  size: (0, _propTypes.shape)({
    width: _propTypes.number.isRequired,
    height: _propTypes.number.isRequired
  })
};

var ChoroplethMap = function ChoroplethMap(props) {
  var domain = props.domain,
      isBlurred = props.isBlurred,
      size = props.size,
      statesData = props.statesData; // They're split
  // into groups so we can add the drop shadow by quartile layer

  var statesQuartileGroups = R.compose( // make sure they're in order
  R.sort(R.descend(R.prop("quartile"))), R.map( // make the quartile a number
  R.compose(R.evolve({
    quartile: parseInt
  }), R.zipObj(["quartile", "states"]))), R.toPairs, // split into quartiles so we can add the drop shadow
  R.groupBy(R.prop("quartile")))(statesData);
  return _react.default.createElement(S.Svg, {
    isBlurred: isBlurred,
    hasData: !!statesQuartileGroups,
    viewBox: size ? "0 0 ".concat(size.width, " ").concat(size.height) : undefined
  }, _react.default.createElement("defs", null, dropdshadowFilter), _react.default.createElement("g", null, statesQuartileGroups && statesQuartileGroups.map(function (_ref) {
    var quartile = _ref.quartile,
        states = _ref.states;
    return _react.default.createElement("g", {
      key: quartile,
      filter: "url(#dropshadow)",
      className: "states-quartile-".concat(quartile)
    }, states.map(function (stateData, i) {
      var color = (0, _color.quartileColor)(domain.id, quartile);
      var abbreviation = stateData.abbreviation,
          d = stateData.d;
      return _react.default.createElement("g", {
        key: abbreviation,
        className: "state"
      }, _react.default.createElement("title", null, name), _react.default.createElement(S.StatePath, {
        color: color,
        d: d
      }));
    }));
  })));
};

var dropdshadowFilter = _react.default.createElement("filter", {
  id: "dropshadow",
  height: "130%"
}, _react.default.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  stdDeviation: "9"
}), _react.default.createElement("feOffset", {
  dx: "1",
  dy: "3",
  result: "offsetblur"
}), _react.default.createElement("feComponentTransfer", null, _react.default.createElement("feFuncA", {
  type: "linear",
  slope: "0.6"
})), _react.default.createElement("feMerge", null, _react.default.createElement("feMergeNode", null), _react.default.createElement("feMergeNode", {
  in: "SourceGraphic"
})));

ChoroplethMap.propTypes = propTypes;
var _default = ChoroplethMap;
exports.default = _default;

},{"../../common/domains.js":6,"../../common/locations.js":10,"../../styles/color.js":51,"./ChoroplethMapStyles.js":31,"prop-types":"prop-types","ramda":"ramda","react":"react"}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatePath = exports.Svg = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Svg = _styledComponents.default.svg.withConfig({
  displayName: "ChoroplethMapStyles__Svg",
  componentId: "sc-1gyap3n-0"
})(["position:absolute;top:0;left:0;width:100%;height:100%;", ";transition:opacity 500ms;"], function (props) {
  return (0, _styledComponents.css)(["opacity:", ";"], props.isBlurred ? "0.1" : !props.hasData ? "0" : "1");
});

exports.Svg = Svg;

var StatePath = _styledComponents.default.path.withConfig({
  displayName: "ChoroplethMapStyles__StatePath",
  componentId: "sc-1gyap3n-1"
})(["fill:", ";stroke:white;stroke-width:1;"], function (props) {
  return props.color;
});

exports.StatePath = StatePath;

},{"styled-components":"styled-components"}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.propTypes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var S = _interopRequireWildcard(require("./MapStyles.js"));

var _propTypes = require("prop-types");

var _locations = require("../../common/locations.js");

var _domains = require("../../common/domains.js");

var _ChoroplethMap = _interopRequireDefault(require("./ChoroplethMap.jsx"));

var _Overlay = _interopRequireDefault(require("./Overlay.jsx"));

var _Boxes = _interopRequireDefault(require("./Boxes.jsx"));

var _UsSvg = _interopRequireDefault(require("./UsSvg.jsx"));

var _useBoundingClientRect = _interopRequireDefault(require("../../lib/useBoundingClientRect.js"));

var _d3Geo = require("d3-geo");

var _albersUsaPr = _interopRequireDefault(require("./albersUsaPr.js"));

var _labelNudge = require("./labelNudge.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  domain: _domains.domainMetadataShape,
  geojson: _propTypes.object,
  hoveredStateId: _propTypes.string,
  selectedLocation: _locations.locationMetadataShape,
  onDeselect: _propTypes.func.isRequired,
  onStateHover: _propTypes.func.isRequired,
  onStateSelect: _propTypes.func.isRequired,
  locationRanks: (0, _propTypes.objectOf)(_locations.locationRankShape).isRequired
};
exports.propTypes = propTypes;

var Map = function Map(props) {
  var domain = props.domain,
      geojson = props.geojson,
      hoveredStateId = props.hoveredStateId,
      selectedLocation = props.selectedLocation,
      onDeselect = props.onDeselect,
      onStateHover = props.onStateHover,
      onStateSelect = props.onStateSelect,
      locationRanks = props.locationRanks;
  var selectedLocationId = selectedLocation && selectedLocation.id; // We need these dimensions to draw the choropleth map to fit inside this container

  var _useBoundingClientRec = (0, _useBoundingClientRect.default)(),
      _useBoundingClientRec2 = _slicedToArray(_useBoundingClientRec, 2),
      mapRef = _useBoundingClientRec2[0],
      size = _useBoundingClientRec2[1]; // this calculation is expensive, so cache it here in state


  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      statesData = _useState2[0],
      setStatesSvgData = _useState2[1];

  (0, _react.useEffect)(function () {
    // only calcualte the map if we have a size
    if (size && geojson && locationRanks) {
      setStatesSvgData(getExpensiveD3Calculations(size, geojson, locationRanks));
    }
  }, [size, locationRanks, geojson]); // if the maps are faded out, because a state or the US are selected

  var isBlurred = (0, _locations.isState)(selectedLocationId) || selectedLocationId === _locations.usa.id;

  return _react.default.createElement(S.Map, {
    ref: mapRef
  }, !statesData ? "loading..." : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ChoroplethMap.default, {
    domain: domain,
    isBlurred: isBlurred,
    statesData: statesData,
    hoveredStateId: hoveredStateId,
    size: size
  }), _react.default.createElement(_Overlay.default, {
    domain: domain,
    hoveredStateId: hoveredStateId,
    onStateSelect: onStateSelect,
    onStateHover: onStateHover,
    onDeselect: onDeselect,
    selectedLocation: selectedLocation,
    size: size,
    statesData: statesData
  }), _react.default.createElement(_Boxes.default, {
    isBlurred: isBlurred,
    domain: domain,
    hoveredStateId: hoveredStateId,
    statesData: statesData,
    onStateSelect: onStateSelect,
    onStateHover: onStateHover
  }), _react.default.createElement(S.UsButton, {
    isBlurred: isBlurred,
    onClick: function onClick() {
      return onStateSelect(_locations.usa.id);
    },
    domain: domain
  }, _react.default.createElement(_UsSvg.default, null), " View U.S. Data"), _react.default.createElement(S.UsOverlay, {
    isSelected: selectedLocationId === _locations.usa.id,
    domain: domain
  }, _react.default.createElement(_UsSvg.default, null), " ", _react.default.createElement("span", null, "United States"))), selectedLocationId && _react.default.createElement(S.BackButton, {
    onClick: onDeselect
  }, "< Select another location"));
};
/**
 * getExpensiveD3Calculations to caclulate states date.
 * @param  {Object} size : { width, height }
 * @param  {Object} geojson: geojson FeatureCollection
 *                  { type: "FeatureCollection", features: [...]}
 * @return {Array} Array of States: { abbreviation, bounds, centroid, d, dx, dy, name, quartile }
 */


function getExpensiveD3Calculations(size, geojson, locationRanks) {
  var projection = (0, _albersUsaPr.default)() // magic number to make the us full width...
  // https://github.com/d3/d3-geo#projection_scale
  .scale(size.width * 1.2).translate([size.width / 2, size.height / 2]);
  var path = (0, _d3Geo.geoPath)(projection);
  return _ramda.default.compose(_ramda.default.map(function (stateFeature) {
    // quartile, ranks, id
    var properties = locationRanks[(0, _locations.idString)(stateFeature.id)];
    return _objectSpread({
      bounds: path.bounds(stateFeature),
      centroid: (0, _labelNudge.nudgedCentroid)(properties.abbreviation, path, stateFeature),
      // centroid: path.centroid(stateFeature),
      d: path(stateFeature)
    }, properties);
  }), _ramda.default.filter(function (stateFeature) {
    return (0, _locations.byId)(stateFeature.id) !== undefined;
  }), _ramda.default.prop("features"))(geojson);
}

Map.propTypes = propTypes;
var _default = Map;
exports.default = _default;

},{"../../common/domains.js":6,"../../common/locations.js":10,"../../lib/useBoundingClientRect.js":49,"./Boxes.jsx":29,"./ChoroplethMap.jsx":30,"./MapStyles.js":33,"./Overlay.jsx":34,"./UsSvg.jsx":36,"./albersUsaPr.js":37,"./labelNudge.js":38,"d3-geo":"d3-geo","prop-types":"prop-types","ramda":"ramda","react":"react"}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsOverlay = exports.UsButton = exports.BackButton = exports.Map = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = require("../../styles/color.js");

var _polished = require("polished");

var _OverlayStyles = require("./OverlayStyles.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Map = _styledComponents.default.div.withConfig({
  displayName: "MapStyles__Map",
  componentId: "fmy3lg-0"
})(["position:relative;display:flex;align-items:center;justify-content:center;width:800px;padding:0 10px;box-sizing:border-box;max-width:100%;&::after{padding-top:", "%;content:\"\";}"], 7 / 10 * 100);

exports.Map = Map;

var BackButton = _styledComponents.default.button.attrs({
  type: "button"
}).withConfig({
  displayName: "MapStyles__BackButton",
  componentId: "fmy3lg-1"
})(["position:absolute;top:12px;left:12px;text-decoration:underline;background:transparent;border:0;cursor:pointer;"]);

exports.BackButton = BackButton;

var UsButton = _styledComponents.default.div.attrs({
  role: "button"
}).withConfig({
  displayName: "MapStyles__UsButton",
  componentId: "fmy3lg-2"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;position:absolute;top:0;left:50%;transform:translateX(-50%);z-index:1;padding:4px 12px;color:", ";font-size:11px;background-color:", ";cursor:pointer;opacity:", ";pointer-events:", ";}svg{width:21px;height:12px;margin-right:8px;}@media (min-width:600px){padding:8px 12px;font-size:14px;svg{width:28px;height:16px;margin-right:8px;}}@media (min-width:800px){top:12px;font-size:16px;}"], function (props) {
  return (0, _polished.readableColor)((0, _color.quartileColor)(props.domain.id, 0));
}, function (props) {
  return (0, _color.quartileColor)(props.domain.id, 0);
}, function (props) {
  return props.isBlurred ? 0.1 : 1;
}, function (props) {
  return props.isBlurred ? "none" : "auto";
});

exports.UsButton = UsButton;

var UsOverlay = _styledComponents.default.div.withConfig({
  displayName: "MapStyles__UsOverlay",
  componentId: "fmy3lg-3"
})(["width:70%;opacity:", ";z-index:1;pointer-events:none;transition:all ", "ms;transform:scale(", ");svg{color:", ";}span{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:24px;color:", ";text-shadow:0px 0px 3px ", ";white-space:nowrap;}"], function (props) {
  return props.isSelected ? 1 : 0;
}, _OverlayStyles.zoomDuration, function (props) {
  return props.isSelected ? 1 : 0.6;
}, function (props) {
  return (0, _color.domainColor)(props.domain.id);
}, function (props) {
  return (0, _polished.readableColor)((0, _color.domainColor)(props.domain.id));
}, function (props) {
  return (0, _polished.invert)((0, _polished.readableColor)((0, _color.domainColor)(props.domain.id)));
});

exports.UsOverlay = UsOverlay;

},{"../../styles/color.js":51,"./OverlayStyles.js":35,"polished":"polished","styled-components":"styled-components"}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var S = _interopRequireWildcard(require("./OverlayStyles.js"));

var _color = require("../../styles/color.js");

var _propTypes = require("prop-types");

var _domains = require("../../common/domains.js");

var _locations = require("../../common/locations.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  domain: _domains.domainMetadataShape.isRequired,
  hoveredStateId: _propTypes.string,
  onDeselect: _propTypes.func.isRequired,
  onStateHover: _propTypes.func.isRequired,
  onStateSelect: _propTypes.func.isRequired,
  selectedLocation: _locations.locationMetadataShape,
  statesData: (0, _propTypes.arrayOf)(_locations.stateDataShape),
  size: (0, _propTypes.shape)({
    width: _propTypes.number.isRequired,
    height: _propTypes.number.isRequired
  }).isRequired
};

var Overlay = function Overlay(props) {
  var domain = props.domain,
      hoveredStateId = props.hoveredStateId,
      onDeselect = props.onDeselect,
      onStateHover = props.onStateHover,
      onStateSelect = props.onStateSelect,
      size = props.size,
      selectedLocation = props.selectedLocation,
      statesData = props.statesData;
  var selectedLocationId = selectedLocation && selectedLocation.id;
  var svgRef = (0, _react.useRef)(); // this isn't needed because each state is invisible until it's hovered
  // useEffect(
  //   () => {
  //     // bring the hovered state to the front
  //     if (svgRef.current && hoveredStateId) {
  //       const node = svgRef.current.querySelector(
  //         `g[data-state-id="${hoveredStateId}"]`
  //       );
  //       // https://github.com/d3/d3-selection#selection_raise
  //       node && node.parentNode.appendChild(node);
  //     }
  //   },
  //   [hoveredStateId, svgRef.current]
  // );

  var handleStateClick = function handleStateClick(id) {
    // ignore any clicks if there is already a selected state
    if (!selectedLocationId) {
      onStateSelect && onStateSelect(id);
      onStateHover(null);
    }
  };

  var handleMouseEnter = function handleMouseEnter(id) {
    // only hover if there isn't a selected location
    if (!selectedLocationId) {
      onStateHover(id);
    }
  };

  var handleSvgClick = function handleSvgClick(e) {
    if (selectedLocationId) {
      onDeselect && onDeselect();
    }
  }; // https://bl.ocks.org/mbostock/4699541
  // transform to zoom in to the state
  // NOTE must use transform attribute (instead of css transform) because of IE11


  var getStateZoomTransform = function getStateZoomTransform(stateData) {
    // the bounds of this state
    var _stateData$bounds = _slicedToArray(stateData.bounds, 2),
        _stateData$bounds$ = _slicedToArray(_stateData$bounds[0], 2),
        left = _stateData$bounds$[0],
        top = _stateData$bounds$[1],
        _stateData$bounds$2 = _slicedToArray(_stateData$bounds[1], 2),
        right = _stateData$bounds$2[0],
        bottom = _stateData$bounds$2[1]; // use middle of bounding box, not centroid


    var x = (left + right) / 2;
    var y = (top + bottom) / 2;
    var width = size.width,
        height = size.height;
    var dx = right - left;
    var dy = bottom - top;
    var scale = 0.6 / Math.max(dx / width, dy / height);
    var translate = [width / 2 - scale * x, height / 2 - scale * y].map(function (s) {
      return s;
    }) // no px for transform attribute
    .join(", ");
    return {
      scale: scale,
      transform: "translate(".concat(translate, "), scale(").concat(scale, ")")
    };
  };

  var statesDataWithZoom = statesData.map(function (stateDate) {
    return _objectSpread({
      zoom: getStateZoomTransform(stateDate)
    }, stateDate);
  });
  return _react.default.createElement(S.Svg, {
    ref: svgRef,
    onClick: handleSvgClick,
    isZoomed: selectedLocationId !== undefined,
    viewBox: size ? "0 0 ".concat(size.width, " ").concat(size.height) : undefined
  }, _react.default.createElement("g", {
    onMouseLeave: function onMouseLeave() {
      return onStateHover(null);
    }
  }, statesDataWithZoom && statesDataWithZoom.map(function (stateData, i) {
    var id = stateData.id,
        abbreviation = stateData.abbreviation,
        centroid = stateData.centroid,
        d = stateData.d,
        zoom = stateData.zoom;
    var isSelected = id === selectedLocationId; // don't highlight hovered states if there is a state selected

    var isHovered = !selectedLocationId && id === hoveredStateId;
    var color = (0, _color.quartileColor)(domain.id, stateData.quartile);
    return _react.default.createElement("g", {
      key: abbreviation,
      onClick: function onClick() {
        return handleStateClick(id);
      },
      onMouseEnter: function onMouseEnter() {
        return handleMouseEnter(id);
      },
      "data-state": abbreviation
    }, _react.default.createElement("title", null, name), _react.default.createElement(S.StatePathG, {
      className: "state",
      isSelected: isSelected,
      zoom: zoom // transform has to be an attribute because of IE11!
      ,
      transform: isSelected ? zoom.transform : ""
    }, _react.default.createElement(S.StatePath, {
      isSelected: isSelected,
      d: d,
      isHovered: isHovered,
      color: color
    }), _react.default.createElement(S.StateName, {
      textAnchor: "middle",
      stateData: stateData,
      color: color,
      isSelected: isSelected,
      centroid: centroid,
      transform: "translate(".concat(centroid[0], ", ").concat(centroid[1], ")"),
      style: {
        fontSize: "".concat(24 * (1 / zoom.scale), "px")
      }
    }, stateData.name), _react.default.createElement(S.StateAbbreviation, {
      x: centroid[0],
      y: centroid[1],
      dy: "0.35em",
      isHovered: isHovered,
      isSelected: isSelected,
      color: color
    }, stateData.abbreviation)));
  })));
};

Overlay.propTypes = propTypes;
var _default = Overlay;
exports.default = _default;

},{"../../common/domains.js":6,"../../common/locations.js":10,"../../styles/color.js":51,"./OverlayStyles.js":35,"prop-types":"prop-types","react":"react"}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateName = exports.StateAbbreviation = exports.StateTextG = exports.StatePath = exports.StatePathG = exports.zoomDuration = exports.Svg = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Svg = _styledComponents.default.svg.withConfig({
  displayName: "OverlayStyles__Svg",
  componentId: "sc-13guaqx-0"
})(["position:absolute;top:0;left:0;width:100%;height:100%;overflow:visible;z-index:", ";"], function (props) {
  return props.isZoomed ? 1 : "auto";
});

exports.Svg = Svg;
var zoomDuration = 500;
exports.zoomDuration = zoomDuration;

var StatePathG = _styledComponents.default.g.withConfig({
  displayName: "OverlayStyles__StatePathG",
  componentId: "sc-13guaqx-1"
})(function (props) {
  return (0, _styledComponents.css)(["stroke-width:", ";transition:", " ", "ms;"], props.isSelected ? 4 / props.zoom.scale : 2, props.isSelected ? "transform" : "all", zoomDuration);
});

exports.StatePathG = StatePathG;

var StatePath = _styledComponents.default.path.withConfig({
  displayName: "OverlayStyles__StatePath",
  componentId: "sc-13guaqx-2"
})(function (props) {
  // give it a fill that's invisible so onMouseEnter will be fired
  var fill = props.isSelected ? props.color : "rgba(0, 0, 0, 0.001)";
  var stroke = props.isHovered || props.isSelected ? (0, _polished.darken)(0.1, props.color) : "rgba(0, 0, 0, 0.001)";
  var fillTransition = props.isSelected ? "fill 250ms ease 0ms" : "fill 250ms ease ".concat(zoomDuration - 250, "ms");
  return (0, _styledComponents.css)(["fill:", ";stroke:", ";stroke-width:inherit;transition:", ",stroke 250ms;"], fill, stroke, fillTransition);
});

exports.StatePath = StatePath;

var StateTextG = _styledComponents.default.g.withConfig({
  displayName: "OverlayStyles__StateTextG",
  componentId: "sc-13guaqx-3"
})(["transition:all ", "ms;"], zoomDuration);

exports.StateTextG = StateTextG;

var StateAbbreviation = _styledComponents.default.text.withConfig({
  displayName: "OverlayStyles__StateAbbreviation",
  componentId: "sc-13guaqx-4"
})(["display:block;text-anchor:middle;cursor:pointer;font-size:18px;text-anchor:middle;text-shadow:1px 1px 1px ", ";fill:", ";opacity:", ";visibility:", ";transition:opacity ", "ms;"], function (props) {
  return (0, _polished.invert)((0, _polished.readableColor)(props.color));
}, function (props) {
  return (0, _polished.readableColor)(props.color);
}, function (props) {
  return props.isHovered ? 1 : 0;
}, function (props) {
  return props.isHovered ? "visible" : "hidden";
}, function (props) {
  return props.isSelected ? "0" : "250";
});

exports.StateAbbreviation = StateAbbreviation;

var StateName = _styledComponents.default.text.withConfig({
  displayName: "OverlayStyles__StateName",
  componentId: "sc-13guaqx-5"
})(["opacity:", ";fill:", ";text-shadow:0px 0px 3px ", ";cursor:default;transition:all 500ms;"], function (props) {
  return props.isSelected ? 1 : 0;
}, function (props) {
  return (0, _polished.readableColor)(props.color);
}, function (props) {
  return (0, _polished.invert)((0, _polished.readableColor)(props.color));
});

exports.StateName = StateName;

},{"polished":"polished","styled-components":"styled-components"}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {};

var USSvg = function USSvg(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 960 600"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    d: "M277.282 443.133l-17.103-2.121-1.29 10.012-15.863-2.099-26.529-3.875-11.545-1.794-5.138-2.963L165.5 420.38l-25.37-15.301 2.71-4.6-25.84-3.057-19.032-2.25-1.54-3.46.77-10.257-3.508-6.932-7.527-9.983-5.308-1.245.86-2.08-1.3-4.63-7.496-2.244-4.288-3.401-.38-2.572-3.009-3.641-6.837-2.473-4.368-2.63-5.978-.97-2.319-3.711 1.42-2.215.8-6.365 1.039-3.577-3.789-3.536 1.39-3.256-2.01-1.876-3.978-8.895-4.008-10.457-2.309-3.512 1.42-7.02 1.829-.017 1.419-4.138-1.27-3.338-3.128-.356-2.25-4.185-1.349-2.46 1.08-3.525-.95-4.08 1.4-3.98 1.869.532-.19 2.66 3.469 3.945 1.01.438-.69-5.079-2.09-3.29-.01-.07.98-2.333-1.55-1.987 3.34-1.327-1.69-2.39-1.76.246-2.448 6.119-3.789-5.26-3.138-1.076 2.049-3.173-.06-3.11-1.12-3.968-2.639-3.484-2.029-5.377-2.189-5.026 1.41-2.01-.15-7.377 2.169-3.682.43-6.447-1.7-4.5-3.778-7.277.43-4.044 7.596-9.165 1.08-4.786 3.598-6.476.23-6.412-1.16-1.362 2.12-4.424-1.51-3.203.92-7.37 1.6-2.677-.77-6.487 1.879-2.093 3.599-6.318 4.778-6.534 2.578-5.144 3.349-8.644 6.697-15.95 4.988-12.9.33-2.729 2.08-4.646.159-4.939 1.22 1.637 5.867-.333-2.479-1.45-2.509.403-1.75-3.945 1.41-5.254 1.98 2.776-1.34-6.388 4.488-2.227-3.788-2.84.38-11.79.28-4.85-1.73-3.653.66-6.844 3.199-3.256 7.067 6.868 10.235 4.196 1.53-.707 2.798 3.139 2.9-.959.06 5.512-6.558 4.985-1.08 1.683 9.486-6.154-1.939 8.568-1.4 2.07-.739 2.512-3.268 2.794-1.24-3.448 1.19-1.876-1.98 3.729 2.04 2.069 5.367-3.478 1.54-.205-.03-5.26 1.589-4.202 3.918-4.693-1.17-4.904v-.55l.67-.853-3.118-5.763 2.819 1.695.82-3.781.62-2.25-2.93-1.649.64-4.78 27.239 7.627 28.967 7.423 9.227 2.226 11.085 2.59 5.747 1.332 14.264 3.092 19.212 3.986 9.586 1.917 27.379 4.986 13.504 2.297 7.727 1.198 18.412 2.706 18.423 2.536 15.563 1.917 15.743 1.783 15.564 1.578 14.914 1.333 16.423 1.303 13.584.941 7.767.456 19.482 1 9.735.397 7.807.251 15.574.392 10.695.175 12.225.123 16.113.006 2.46-.024-.07-8.498 4.867 1.935 2.14 11.356 3.908 1.648 8.776 1.409.8 2.49 10.475-2.753 8.816 3.682 2.26 4.95 1.489-3.039 3.099-.216 3.998 3.29 3.628 3.36 4.728-1.121 3.16-2.478 2.128-1.38 2.04 3.156 9.435-.847 4.099 2.53 4.288.158-5.618 3.379-8.326 3.337-7.077 5.681-4.798 5.985-6.388 6.242-4.448 3.571 1.28 1.76 7.077-1.415 8.646-4.565 3.469 1-2.33 6.879 2.78-2.543 3.028 2.245 2.04.28 5.847-2.77 2-2.163 7.146-2.226 7.067-4.705 5.978-6.114 4.708-4.208 5.727-.83 1.51 1.362-7.467 5.23-2.94 6.062.26 3.986 2.92-4.033 3.078.129 6.478 1.683 4.688 6.388 3.868-.082 6.547.637 8.057-6.06 4.148-.825 5.878-.42 3.538-2.087 4.338-.807-.23 6.523 6.588.666 2.469-2.226 4.378-1.199.99 6.529-1.89 1.543 3.579.543.85 2.116 3.118.433.07-2.151 2.939-.35.81 3.874-8.707-.356-3.918 1.525-4.648-2.145-2.22 4.32-3.008-2.66-8.207-.976-1.899 2.992-3.119.31-5.107.655-3.609 4.968-3.618 2.8 2.329-4.8-3.939.229-.58 3.144-3.398.637-2.859 3.811-4.178 10.59-2.46 3.127-3.028 6.734 1.23 3.074 2.429-2.648.35-.76 1.669-3.77 3.079-1.765 2.099-6.09 3.728-3.226-.59 4.688-4.258 9.684-1.98 8.007.66 3.262-1.869 1.858-.94 4.869.82 4.716-1.149 3.174-.9 7.984 1.73 7.738.68 3.875.43 3.934-.19 4.313 1.519 3.238 4.748 9.609 5.137 1.438 4.599-2.397 1.669-1.274 3.089-3.326 3.388-8.235 1.08-4.091.26-7.902-1.83-7.732-3.868-7.599-1.65-3.717 1.37-4.08-1.87-5.19 1.76-2.892 1.65-7.82-.41-4.185 2.339-1.865-.19-2.852 3.968-1.414 2.379-5.588 1.14 2.747-.47 6.447 2.059-5.091.84 2.858v-7.826l4.148-4.056-.89-4.442 2.35-3.858 3.088-1.7 4.558 2.501 4.058.064 1.82 2.52 3.158.035 6.787 2.01 2.14 3.104 2.358 3.828-2.139-.772-.35 2.712 2.2 1.824 1.08 7.686.289 3.834-3.159 4.418.01 2.414-4.728 3.922.66 5.29 3.558 1.15 3.23-3.36 2.648-5.833 5.178-2.905 3.059 1.409 3.048 6.341 3.299 11.356 2.059 4.057-.6 8.48-2.359 2.35-.86-3.618-1.909 5.54-2.738 3.402-1.11 6.698-3.498 7.207 5.057 1.806 4.139 1.911 1.419-1.864 2.579 1.765 3.868 2.01 2.05-1.362 5.987-2.653 3.728-.123 3.709-3.846 2.859-3.378 4.318-2.84 7.427-3.992 11.195-8.557 8.926-8.416 3.689-5.564-3.789-5.757-1.599-4.19 9.186-4.168 7.487-1.28 3.908-.111 3.979 1.572 2.329-1.45 6.747-1.192 3.318-2.35 1.32-2.004 5.817-4.793-.44-2.32-2.278-3.144 2.419-1.877-4.509-2.11.21-3.88 6.108-5.98.92-2.776 6.447-9.456 3.578-3.472 3.729-1.105 10.745-2.507 10.416-2.84 2.299-.626 9.796-2.309 10.035-2.56 6.018-1.695.5-5.219 4.168-2.782 3.958-.362.3-5.64 1.65-3.986 3.088-6.015-1.809-3.524-.05-6.16 1.74-2.455-.45-3.5-.34-2.725 6.697-19.58 2.839-.081 1.19 3.875 2.448.824 4.028-3.711 5.948-2.66 6.987 3.864 7.467 23.91 1.35 5.722 5.817.018 1.52 7.02 3.288 2.659 2.499-1.614 4.988 6.634-2.02 4.524-2.209-.76-2.509 6.873-3.398-1.32-2.02 3.723-3.228 1.683.04 2.758-2.529 1.105-1.63-3.887-1.798 1.584 1.669 3.536-.72 2.765-.61.012-1.23-3.016-2.578-.351-.96-4.687-1.719 6.943.98 6.143-4.528 1.59-1.19 3.238-2.929 1.133-2.629 1.859-3.518 3.209v2.712l-2.25 1.32.06 4.04-1.708 1.04-.99 6.715-.68 4.553 1.66 3.711 3.088-.07-3.678 3.659-.81 2.607.27 2.969.77.456 2.159-.146.78.117 3.188 2.934.41 2.875 2.879 2.706 4.388.579 3.918-2.338-.37-3.682 2.49 5.324-6.198 3.028-4.568 4.126-.48-.158-.31-4.412-2.669 2.823-1.1 2.945-2.578 1.105-3.669 1.841 1.43-5.383-.67-.649-2.459-.409-.37.065.22 2.36.42 6.46-5.778 2.705-7.526 2.87-3.04 1.338-5.897 1.643-2.858 2.548-7.937 6.184-1.22 2.8.08 1.73.28-.042 3.789-3.752 4.458-.666 1.11-1.69 8.116-2.378 3.688-4.606 4.778 2.175-3.938 3.968-9.636 7.055-5.717 2.711-5.238 1.725-2.89 1.157-2.028-2.098-.46-.123-.22.742-2.309 4.203.84.94 3.928.059 1.06 6.932.67 7.668-2.23 6.616-2.799 5.26-2.668 7.744-2.75 1.818-.22-5.435-3.448-.035-5.787-2.63-2.53-1.257-1.029-3.133-.17-.514.55-1.42-1.27 2.326 2.78 4.74 2.768 3.115 2.62 5.395 4.467 2.443 2.39 7.457-1.19 10.07-1.14 3.77-2.919 3.84-.64 6.436-1.129 6.481-2.029 2.14-1.87-2.777.14-6.774 2.67-9.83-3.779 1.408-1.69-3.98.78-3.051-.5-2.52-1.299 2.73-3.328.778-4.069-4.892.42-2.794 4.418-.076-6.107-3.332 1.92-2.203-.97-1.905-2.01 2.542.38-4.442 2.16-1.706-2.26-.72.94-4.494 2.609-1.572-.32-4.109-1.69.696.69 2.051-2.279 2.671-2.419-.345.85 2.876-3.039 1 .08.777 3.259 3.828-1.68 5.967.77 1.082 1.07 4.032 2.819 2.666-1.11 1.7 3.868 5.658-5.397-2.811-3.629.228-1.39-2.443.55 2.209-3.818-3.624-2.869 2.548-1.679-2.466 1.77-3.88-1.58.245-.77 3.226.95 3.396 4.568-1.514.67 2.086 3.228 1.982 3.899-.456 2.129 2.174 5.498 2.21-.46 4.903-3.079 1.525-2.949-2.846-5.447-3.635 4.848 4.272 6.747 4.19 2.369 4.513-2.64-1.526 1.54 2.59-2.429 1.268 2.1 1.327 2.128.637-1.15 3.185-4.667-3.115-4.988-1.14-1.06.83 5.108 1.075 4.218 4.04 1.49.414 1.36-.093 2.298-1.45 3.469-.275 3.858 7.482 3.149 6.686 6.327 8.872-4.368-4.027-2.309-4.676-3.049-5.219-2.609-.1 6.098 7.868-3.449-2.554-.68 1.741-3.448-1.724 2.879 2.7-3.928-.081 1.429 1.852-3.319 1.163-2.649 2.122-3.108-2.6-.07-2.964-.34.841 1.85 6.506 5.737-1.193 6.097-1.578.84 6.558.52-.199-.18-6.575 2.978-.181 2.36 5.067-2.22 3.045-3.618 6.628-6.258.327-2.408-2.665 1.879-1.467-2.74 1.613 1.53 2.52-5.727.105 5.477 1.098 2.81 1.163-1.46 4.752-3.109 3.022-3.159-1.268 4.049 2.098 1.21-1.228 3.018-1.642 4.308.643-1.99 2.227-1.219 4.383 6.268-10.38.68.24-4.958 7.364-1.76 4.88-2.988-1.788-7.467 2.73-6.458 5.88-2.848 3.845-2.5 8.93-.09 1.748-4.197-.596-6.308 2.636-4.488 3.29-2.749 4.413-1.879 4.77.08 4.663-1.64 1.742-.859 2.513-3.089-.11-.48 3.033-4.438 4.208-2.239 3.787-4.748 2.829-3.598 1.315.81 3.653-2.97 1.935-3.818 4.611.02 1.029.66 1.373-4.588 6.26-.82.128.63 3.49-.47 6.283-2.309 6.663 1.03 6.797.71 4.419 2.079 5.5 5.197 12.367 2.98 5.038 3.588 5.745 5.777 7.13 5.208 6.646-1.08 3.518 1.59 4.612 3.179 4.775 3.568 6.248 3.479 6.05 3.438 6.007 1.6 3.653.9 10.538.419 7.698.39 6.879-1.98-.824-1.159 9.41 1.98-1.368.399.146-1.46 4.483-2.418 2.776-.52-3.331-7.237 1.695-4.278 1.975-2.22-1.964.62-2.7-4.598-7.084-3.968-1.975-4.598-.403-3.029-4.816-1.68-5.167-6.816-5.874 1.07-3.138-.89-4.08-2.24 4.57-1.089-.298-2.569-3.138-6.677-9.001-1.53-2.215 2.47-3.659 2.558-4.687-5.577-3.314-1.26 1.8 3.11 2.519-2.63 2.84-2.779-3.647-1.04-6.277.58-.076.48-.076 1.66-6.107-.62-5.787-2.679-6.359-1.36-3.267-3.798-.18-3.618-2-1.4-2.776-3.798-1.672-.67-3.284-2.579-.924-2.399-3.36-7.347-3.513-1.649-.053-3.708.415-1 3.209-3.598 1.578-6.368 4.98-4.398.666 1.81 2.689-3.71-1.625-2.408.69.64-3.163-2-2.641-12.484-6.394-7.937-1.643-7.697.585-2.279.578-11.295 3.075-6.038 1.724 1.47-1.567-3.119-2.384-1.06-5.483-1.419-.496-1.77 8.328-5.047-.683-2.02 1.239-6.037-.754-2.099-.246-6.937 2.537-1.06-1.49.32 1.548-3.548 2.987-1.86.76-4.257 3.764 5.147 2.25 1.94-4.565 2.459 3.589-.88 5.78-1.96-.175-2.758 2.577 3.688 3.717 6.038.439 2.459 3.88-.76 3.97-2.269-1.889-3.049 3.647 1.81-4.325-6.638-3.413-5.157.24-3.419 3.144-2.509 1.917-3.229-4.237-.06.608-.38-.094-3.678.398-4.088 4.944-3.069-2.934-7.407-2.256 1.28-1.455 2.919 2.303-2.48-4.045-4.358-.503-3.388-5.78-4.598.193-2.29-2.08-4.337 1.969 1.909 3.045-4.109 2.005-5.757-1.011-10.986-3.764-5.777.192-6.987 1.93-3.159.274-6.797 2.8-.32.151-7.647 3.735 4.918-3.407-5.238.339 1.58-5.085-4.538 1.929-1.66 2.682 2.13 1.269.35 4.208-3.19 2.379-.899 1.8 5.698-5.208 1.56.462-7.508 5.757-5.118 4.757-2.439.924-13.484 7.23-3.628 2.478-9.396 7.306-3.849 4.933-3.628 5.74-2.56 6.604-.529 8.708 1.46 6.347 1.249 4.203-.39-.006-1.36-4.202-1.429-4.46.39-10.602 2.259-6.593 3.878-7.504 5.058-4.94 7.377-6.165-4.568 2.297-1.62-2.163-.489 2.04-.17 1.034-.22 1.234-2.489 2.057-1.819-1.374-3.738 2.362 3.758-.748-2.21 4.64-7.106.316-.24.877 2.489.18 2.439 3.18-1.46 2.999-1.829 5.3-4.478.807 4.268.602-1.28 9.995.68 4.6 1.78 4.202 1.11 6.815 2.788.976.09 2.36-7.637 1.427-2.529-3.033-4.428-.86-7.696-.531-6.738-4.203-1.669.368-3.049-3.068-5.727-1.409-1.08-3.26-1.789-6.091-3.419-4.115.05-5.365-.35-4.933-2.318-3.56-5.308-3.717-.9-4.08-5.338-5.037-1.529-2.023-1.74-6.78-4.237-7.305-.52-4.068-2.3-3.641-4.907-5.109-3.809-1.952-3.838-5.675-5.518-.368-6.847-.649-3.838-2.192-1.44 2.414-5.897.585-2.659 4.296-2.649 7.235-4.188 4.29-3.239-.175-9.496-6.979-6.557-3.314-7.097-7.188-2.2-5.78.37-5.694-2.868-5.003-1.84-5.529-2.208-2.793-5.208-3.028-3.419-5.465-3.028-2.203-3.729-5.348-3.748-2.186-2.65-6.295-2.648-1.443zM400.1 268.126h.02-.02zm167.58 235.172l3.259-.952 2.688 1.484-2.508 1.818zm60.035-13.863zm-8.877.514l2.75-2.496.52 2.619zm-18.672 22.49zm-3.538.532zm-3.709 1.064zm21.211-12.022zM885.417 192.35zm-2.49 2.332zm-79.966-43.525zm-1.33-.088zM178.255 550.137l-4.748-2.256-2.71-3.845-2.048-1.637 3.218 6.412-1.999-1.14-4.568 2.735-6.048-3.226-1.809-1.537-8.906-3.133-10.206-1.28-4.018 1.514-10.686-4.062-1.17-2.063-5.147 1.777 1.78 5.663-2.9 1.204-4.508.246-4.648 5.944-3.898-.088 1.78-3.045-1.48-1.011 1.68-3.665-.16-3.857 3.788-2.683 5.168 1.198-4.089-2.18 2.25-2.595-1.95 1.935-3.688.56-6.448 8.189-1.18 3.817-4.187 2.583-.17 2.73 3.618 1.262-3.218 2.881-.63 2.77-7.687 4.355-1.41 3.127-6.727 5.061-2.998 3.688-4.388.649-.4 1.666-1.19-1.695-3.238 2.577-4.379.421-2.239 1.754-4.938.654-2.818 2.215-5.888.626 1.81-3.139 7.826-1.473 5.368-4.886 4.418-.596 4.758-3.653 4.098-1.69 5.398-5.598 2.269-8.154 1.18-2.057-.85.275-3.899 1.595-1.529-1.46-2.329 2.7-2.379-4.185-2.239-1.31-3.049 1.526-.16.082-1.15.555-1.828 1.274-.54-5.745 1.6-1.55-1.97-5.587-5.368 2.21-5.637-6.552 1.439-3.057-2.969-5.243 2.61-4.523 6.836-7.762 2.62 2.14 2.768-1.48 1.33-1.53 3.938.326 1.5-1.963-1.48-6.137.99-2.946-4.829 2.501-8.356-.479-3.838-1.864-1.3-4.67 1.94-.719-4.959-4.26 8.167-3.543 4.668-1.169 1.78.187-.43 4.12 6.037 1.111 2.849-1.344-2.99-3.565 1.97-2.432-6.587-1.97-.31-3.266-3.439-4.483-3.328-3.267 2.119-3.595 5.578.55 3.238-2.45 1.18-3.775 3.538-3.554 2.89-.04 3.368-2.9 4.968-.274 2.638-3.01 4.549 1.204 1.17 2.46 6.166-.04-.48 1.66 3.45 1.665 4.427-1.332 4.948 2.045 4.928-.274 3.529 1.052 3.448-1.947 6.747 2.741 1.72 8.691 4.018 20.287 5.998 30.223 2.309 11.643 4.158.8 3.108-2.074.04 2.139 7.647 5.009.95 2.466 3.318-3.711-.17-2.718 2.13-1.666 3.448 2.157 3.549 2.069 6.367 4.676 3.409 3.349 3.918 4.617 5.438 2.116 4.248 1.022 1.31 2.274 2.028 3.25-1.459 5.277-2.939-2.87-5.767-1.636-3.319-2.835.94-2.215-1.78-2.472-5.037-2.18-1.56-4.401-.39-.596-.08.234zm6.447 10.807zm-.48-.882zm-8.726-12.052l3.078 5.61-1.779 3.233-3.558-8.697zm-7.997 4.974l-1.24-1.654 2.63-2.426 3.738.871.06 2.268-1.56 3.717zm14.094 2.53l4.228 2.134-3.348 1.841-2.62 3.88-2.308-5.248 1.57-2.53zM70.69 584.219zm-.74-1.958zm-2.809 1.788zm-2.399-3.29zm-4.808 1.046zm-2.549 1.169zm-2.279 3.472zm-11.185 1.057zm-1.9-1.507zm-2.018.473zm57.575-25.658l4.279-4.577 1.22 3.77zm-3.958 11.935zm-1.72-6.47l5.548-4.676 4.059-.053 1.39 2.654-5.189 4.325-3.798 1.84zm-.2 7.3zm-4.187 4.687zm31.436-32.023zm-.41-3.583zm74.92 25.19zm-10.097-.128zm-1.3-3.746l1.86-3.495 7.487 6.23 1.28 4.173-5.998-2.53zm-2.178 1.116zm-1.96-2.46l.12.888-4.667-4.197-2.15-3.588 3.29-1.298zm-7.096-5.752zM43.51 538.74l5.238-.794 1.43 4.47-2.57.796zm-20.441-7.475zm43.401 23.899zm127.887 13.074zm-2.69-2.495zm-221.426 17.335zm-4.888.824zm-5.478-4.676zm-14.824-11.818zm-1.799-5.605zm87.533 29.434l2.45-.362L37.362 587l2.139 1.671-3.469 2.63zm-6.287 2.221l4.308-3.927 2.14 1.174zm3.519-29.323zm-7.927 28.406zm6.337-33.25zm-10.635 34.15zm-8.857.005zm-6.957-.736zm-6.127-1.11l5.168.14-.97 1.216zm-3.868-1.736zm-.81 1.8zm-3.978.216l1.879-2.11 1.969 1.467zm-3.06-1.77zm-1.878-2.152zm122.308-45.15zm-37.434-27.26zm-31.217-6.025l4.888.064 5.328 4.512-3.918 1.982-1.84-3.262zm619.34-378.711zm-1.08 5.324l.59-3.705 1.54 3.209zm-1.449-2.94zm15.953-4.675l4.808 1.46-2.149 1.041zm-31.067 8.907zm13.005 2.566zm-2.13 7.043zm-1.139 3.039zM592.13 90.665l8.566-6.482 3.419-1.42-3.399 4.255-6.527 4.553zm33.256 395.286zm-3.329-.263zm12.515-.456zm-5.068-.245zm78.137-266.447zm1.91.73zm125.507 57.518l.16-.654-.16.654zm.82 3.682l.899-.192-.9.192zM567.15 112.015zm64.923 31.708zm-6.237 4.01zm-50.81-36.53zm-.759 2.864zm-1.999-.982zm-1.57 2.01zm.17-2.8zm-.63-1.302zm.07 5.33zM55.746 349.28l5.927 3.407-5.657-1.087zm-6.267.128l3.828.205.71 2.355-2.9.333zm-3.379-1.712zm18.072 4.845zm-6.787 15.699zm18.622-.006l3.859 2.572-2.18 1.356zM73.597 378l3.469 5.67-2.439-1.274zm691.89 171.407zm-56.127-62.111zM802.052 585zm-1.83 1.49zm-5.217 2.987zm-13.515 5.167l1.05-2.186 5.627-4.284 4.538 2.402-8.606 3.898zm-4.048 1.18zm-3.119.006zm-15.893.719zM925.3 112.746zm-1.77 1.297zm-1.609-3.834zm-4.068 3.723zm-2.05.24zm3.34 8.346zm-2.12-5.453l1.37-2.116 1.579 2.262zM91.78 49.77zm5.438-25.88zm-1.03-1.1zm-2.11-5.429zm-1.908 1.59zm-2.55 1.642l4.809-1.292 2.199 1.818-2.47 4.804-3.977-2.776zm.1-2.104zm7.628 1.24zm-3.589-7.26zm-.19 17.768l3.439-3.244.8 2.852-1.87 2.034-.31 3.828 2.45.275-1.52 2.326-1.85-3.208.64-2.77zm760.58 310.165l-.15-.304.15.304zm-3.188-16.628zm-212.97 160.78zm-350.853 64.479l2.259-2.496 2.469 3.069 3.148-1.245 6.758 3.413-1.04 3.144-6.807 1.707-1.83-4.512-3.518-.87zm-.04 8.627l2.639-1.654.57 1.917zm-7.567-8.259l3.469-.245 1.839 2.355-3.319 1.648zm3.029-5.862l4.378.21-3.519 2.432-9.096-1.163 1-2.648 5.218.789zm18.172 31.66l4.798-6.54-1.51-2.449.96-2.8 5.328 3.198 6.977 2.449 3.948 3.64-.17 2.497 5.918 4.576-3.478 4.056-6.658 1.9-4.398 2.893-3.498 4.933-4.448-2.636-.15-6.698zm-46.64-40.83l3.188-.164 3.299-2.776 2.649 5.622 3.968 3.577-9.676-.105zm-31.507-10.252l1.23-2.42 3.598-1.882 4.368.304.36 5.64-2.42 2.005-3.308-.555zm-9.596 3.898l3.648-3.372-2.848 4.921zm700.416-344.432l5.248-.724-2.32 1.502zm-9.216 1.526l2.928-3.805 3.249 2.238zm-9.726.1zm-1.7 7.451z"
  }));
};

USSvg.propTypes = propTypes;
var _default = USSvg;
exports.default = _default;

},{"prop-types":"prop-types","react":"react"}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = albersUsaPr;

var _d3Geo = require("d3-geo");

// A modified d3.geo.albersUsa to include Puerto Rico.
// https://bl.ocks.org/mbostock/5629120#albers-usa-pr.js
function albersUsaPr() {
  var ε = 1e-6;
  var lower48 = (0, _d3Geo.geoAlbers)(); // EPSG:3338

  var alaska = (0, _d3Geo.geoConicEqualArea)().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]); // ESRI:102007

  var hawaii = (0, _d3Geo.geoConicEqualArea)().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]); // XXX? You should check that this is a standard PR projection!

  var puertoRico = (0, _d3Geo.geoConicEqualArea)().rotate([66, 0]).center([0, 18]).parallels([8, 18]);

  var _point,
      pointStream = {
    point: function point(x, y) {
      _point = [x, y];
    }
  },
      lower48Point,
      alaskaPoint,
      hawaiiPoint,
      puertoRicoPoint;

  function albersUsa(coordinates) {
    var x = coordinates[0],
        y = coordinates[1];
    _point = null;
    (lower48Point(x, y), _point) || (alaskaPoint(x, y), _point) || (hawaiiPoint(x, y), _point) || (puertoRicoPoint(x, y), _point);
    return _point;
  }

  albersUsa.invert = function (coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.12 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : y >= 0.204 && y < 0.234 && x >= 0.32 && x < 0.38 ? puertoRico : lower48).invert(coordinates);
  }; // A naïve multi-projection stream.
  // The projections must have mutually exclusive clip regions on the sphere,
  // as this will avoid emitting interleaving lines and polygons.


  albersUsa.stream = function (stream) {
    var lower48Stream = lower48.stream(stream),
        alaskaStream = alaska.stream(stream),
        hawaiiStream = hawaii.stream(stream),
        puertoRicoStream = puertoRico.stream(stream);
    return {
      point: function point(x, y) {
        lower48Stream.point(x, y);
        alaskaStream.point(x, y);
        hawaiiStream.point(x, y);
        puertoRicoStream.point(x, y);
      },
      sphere: function sphere() {
        lower48Stream.sphere();
        alaskaStream.sphere();
        hawaiiStream.sphere();
        puertoRicoStream.sphere();
      },
      lineStart: function lineStart() {
        lower48Stream.lineStart();
        alaskaStream.lineStart();
        hawaiiStream.lineStart();
        puertoRicoStream.lineStart();
      },
      lineEnd: function lineEnd() {
        lower48Stream.lineEnd();
        alaskaStream.lineEnd();
        hawaiiStream.lineEnd();
        puertoRicoStream.lineEnd();
      },
      polygonStart: function polygonStart() {
        lower48Stream.polygonStart();
        alaskaStream.polygonStart();
        hawaiiStream.polygonStart();
        puertoRicoStream.polygonStart();
      },
      polygonEnd: function polygonEnd() {
        lower48Stream.polygonEnd();
        alaskaStream.polygonEnd();
        hawaiiStream.polygonEnd();
        puertoRicoStream.polygonEnd();
      }
    };
  };

  albersUsa.precision = function (_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_);
    alaska.precision(_);
    hawaii.precision(_);
    puertoRico.precision(_);
    return albersUsa;
  };

  albersUsa.scale = function (_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_);
    alaska.scale(_ * 0.35);
    hawaii.scale(_);
    puertoRico.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function (_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(),
        x = +_[0],
        y = +_[1];
    lower48Point = lower48.translate(_).clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]]).stream(pointStream).point;
    alaskaPoint = alaska.translate([x - 0.307 * k, y + 0.201 * k]).clipExtent([[x - 0.425 * k + ε, y + 0.12 * k + ε], [x - 0.214 * k - ε, y + 0.234 * k - ε]]).stream(pointStream).point;
    hawaiiPoint = hawaii.translate([x - 0.205 * k, y + 0.212 * k]).clipExtent([[x - 0.214 * k + ε, y + 0.166 * k + ε], [x - 0.115 * k - ε, y + 0.234 * k - ε]]).stream(pointStream).point;
    puertoRicoPoint = puertoRico.translate([x + 0.35 * k, y + 0.224 * k]).clipExtent([[x + 0.32 * k, y + 0.204 * k], [x + 0.38 * k, y + 0.234 * k]]).stream(pointStream).point;
    return albersUsa;
  };

  return albersUsa.scale(1070);
}

},{"d3-geo":"d3-geo"}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nudgedCentroid = nudgedCentroid;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// percentage of feature width/height
var nudges = {
  CA: [-0.05, 0],
  FL: [0.08, 0],
  HI: [0.15, 0.2],
  LA: [-0.1, 0],
  MI: [0.075, 0],
  NH: [0, 0.05],
  NJ: [0.1, 0.1],
  RI: [-0.1, 0]
};
/**
 * @param {Object} path : d3.geo.path, eg. const path = geoPath(geoAlbersUsa());
 * @param {Object} feature : geojson Feature. It must have a properties object      with an abbreviation key
 */

function nudgedCentroid(abbreviation, path, feature) {
  // https://github.com/d3/d3-3.x-api-reference/blob/master/Geo-Paths.md#path_centroid
  var centroid = path.centroid(feature);
  var nudge = nudges[abbreviation] || [0, 0]; // bounds of this feature

  var _path$bounds = path.bounds(feature),
      _path$bounds2 = _slicedToArray(_path$bounds, 2),
      _path$bounds2$ = _slicedToArray(_path$bounds2[0], 2),
      left = _path$bounds2$[0],
      top = _path$bounds2$[1],
      _path$bounds2$2 = _slicedToArray(_path$bounds2[1], 2),
      right = _path$bounds2$2[0],
      bottom = _path$bounds2$2[1];

  var width = Math.abs(right - left);
  var height = Math.abs(bottom - top);
  return [centroid[0] + Math.round(nudge[0] * width), centroid[1] + Math.round(nudge[1] * height)];
}

},{}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _calculatePopupOffsets = _interopRequireDefault(require("./calculatePopupOffsets.js"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Popup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popup, _React$Component);

  function Popup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Popup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Popup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      left: 0,
      // left/top will be calcualted before the popup is visible (see hasCalulatedPositionOnce)
      top: 0,
      triangleSide: _this.props.triangleSide,
      triangleOffset: 0
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      // only call recalc after the scroll/resize has stopped
      _this.debouncedRecalc = (0, _lodash.default)(_this.calculatePositions, 250); // make sure we run all these things, like calculatePositions and onFlip

      _this.componentDidUpdate({}, {});

      window.addEventListener("scroll", _this.debouncedRecalc);
      window.addEventListener("resize", _this.debouncedRecalc); // make sure the hidden popups move when their position is calculated
      // see shouldComponentUpdate (only updates if the hidden state changes)

      _this.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function (nextProps, nextState) {
      // there are sometimes errors when there is pixel rounding that can cause
      // update thrashing, so only update if it's changed a signifigant amount
      var hasChangedAlot = function hasChangedAlot(key) {
        return Math.abs(nextState[key] - _this.state[key]) > 2;
      }; // only update if the hidden state changes


      return nextProps.isHidden !== _this.props.isHidden || // or position
      nextProps.top !== _this.props.top || nextProps.left !== _this.props.left || nextProps.width !== _this.props.width || // or if the state changes
      hasChangedAlot("top") || hasChangedAlot("left") || hasChangedAlot("triangleOffset") || nextState.triangleSide !== _this.state.triangleSide || nextProps.triangleSide !== _this.props.triangleSide;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      var triangleSide = _this.state.triangleSide;
      var onFlip = _this.props.onFlip; // calculate the position.  Even if the top/left haven't changed, the window width might have

      _this.calculatePositions(); // call onFlip if we've flipped


      if (triangleSide !== prevState.triangleSide) {
        if (onFlip) {
          onFlip(triangleSide);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "hasCalulatedPositionOnce", false);

    _defineProperty(_assertThisInitialized(_this), "calculatePositions", function () {
      var offsets = (0, _calculatePopupOffsets.default)({
        popup: _this.popup.current,
        top: _this.props.top,
        left: _this.props.left,
        offset: _this.props.offset,
        triangleSide: _this.props.triangleSide,
        triangleSize: 12,
        // used to calculate the top value, should match css
        flipToContain: _this.props.flipToContain || "viewport",
        nudgeToContain: _this.props.nudgeToContain || "viewport"
      }); // update the state with all the measurements

      _this.setState({
        top: offsets.adjustedTop,
        left: offsets.adjustedLeft,
        triangleOffset: offsets.triangleOffset,
        triangleSide: offsets.triangleSide
      }, function () {
        if (!_this.hasCalulatedPositionOnce) {
          _this.hasCalulatedPositionOnce = true;

          _this.forceUpdate();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleXClick", function (e) {
      e.preventDefault();

      _this.props.onXClick();
    });

    _defineProperty(_assertThisInitialized(_this), "popup", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "triangle", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$state = _this.state,
          top = _this$state.top,
          left = _this$state.left,
          triangleSide = _this$state.triangleSide,
          triangleOffset = _this$state.triangleOffset;
      var width = _this.props.width;
      var popupClasses = (0, _classnames.default)("popup", "is-triangle-".concat(_this.state.triangleSide), _this.props.className, {
        "is-hidden": _this.props.isHidden || !_this.hasCalulatedPositionOnce
      });
      var popupStyles = {
        position: "absolute",
        top: top,
        left: left,
        width: width
      }; // center the triangle and nudge if needed

      var triangleStyles = {
        transform: triangleSide === "top" || triangleSide === "bottom" ? "translateX(".concat(triangleOffset, "px)") // top/bottom
        : "translateY(".concat(triangleOffset, "px)") // left/right

      };
      return _react.default.createElement("div", {
        className: popupClasses,
        style: popupStyles,
        ref: _this.popup
      }, _this.props.onXClick && "x", _react.default.createElement("div", {
        className: "popup__html"
      }, _this.props.children), _react.default.createElement("div", {
        className: "popup__triangle",
        ref: _this.triangle,
        style: triangleStyles
      }));
    });

    return _this;
  }

  _createClass(Popup, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("scroll", this.debouncedRecalc);
      window.removeEventListener("resize", this.debouncedRecalc);
      this.debouncedRecalc.cancel();
    }
  }]);

  return Popup;
}(_react.default.Component);

exports.default = Popup;

_defineProperty(Popup, "propTypes", {
  isHidden: _propTypes.bool,
  children: _propTypes.any,
  // content of the popup
  top: _propTypes.number.isRequired,
  left: _propTypes.number.isRequired,
  // having "auto" width can cause bugs when the popup butts up agains the side of the
  // viewport/parent container. The triangle might not point at the correct spot...
  // use a explict width if the popup might need to adjust by flipping/nudging
  width: _propTypes.number,
  onXClick: _propTypes.func,
  onFlip: _propTypes.func,
  offset: _propTypes.number,
  className: _propTypes.string,
  triangleSide: (0, _propTypes.oneOf)(["top", "right", "bottom", "left"]),
  flipToContain: (0, _propTypes.oneOf)(["viewport", "parent"]),
  nudgeToContain: (0, _propTypes.oneOf)(["viewport", "parent"])
});

_defineProperty(Popup, "defaultProps", {
  isHidden: false,
  triangleSide: "bottom"
});

},{"./calculatePopupOffsets.js":40,"classnames":"classnames","lodash.debounce":"lodash.debounce","prop-types":"prop-types","react":"react"}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculatePopupOffsets;

var _propTypes = require("prop-types");

/**
 * calculatePopupPositions: find the top/left
 * @param {element} popup          : DOM elmenet of the popup to be placed
 * @param {number}  top            : The top coordinate of where the popup should point
 * @param {number}  left           : The left coordinate of where the popup should point
 * @param {number}  offset         : an offet to be added to top/bottom or left/right
 * @param {string}  triangleSide   : "top", "right", "bottom", or "left"
 * @param {number}  triangleSize   : used to calculate the position
 * @param {boolean} flipToContain  : "parent" or "viewport" or ""/false. will flip the popup if it goes outside the viewport
 * @param {string}  nudgeToContain : "parent" or "viewport" or ""/false. will nudge t
 * @return {object}  {
 *     relativeTop    : with no offset adjustment, the popup should go here, based on triangleSide, relative to parent
 *     relativeLeft   : ^^
 *     adjustedTop    : with adjustment from nudging or flipping
 *     adjustedLeft   : ^^
 *     overflow       : "top", "right", "bottom", "left".  Positive numbers are overflows
 *     triangleOffset : Amount the triangle needs to move to be on the dot, relative from 50%
 *     triangleSide   : Will be the same as passed in triangleSide, unless it fliped via flipToContain
 * }
 * use adjustedTop, adjustedLeft, and triangleOffset to position the popup
 */
function calculatePopupOffsets(props) {
  var popup = props.popup,
      top = props.top,
      left = props.left,
      _props$offset = props.offset,
      offset = _props$offset === void 0 ? 0 : _props$offset,
      _props$triangleSide = props.triangleSide,
      triangleSide = _props$triangleSide === void 0 ? "bottom" : _props$triangleSide,
      _props$triangleSize = props.triangleSize,
      triangleSize = _props$triangleSize === void 0 ? 12 : _props$triangleSize,
      _props$flipToContain = props.flipToContain,
      flipToContain = _props$flipToContain === void 0 ? "viewport" : _props$flipToContain,
      _props$nudgeToContain = props.nudgeToContain,
      nudgeToContain = _props$nudgeToContain === void 0 ? false : _props$nudgeToContain;
  (0, _propTypes.checkPropTypes)({
    popup: _propTypes.object.isRequired,
    top: _propTypes.number.isRequired,
    left: _propTypes.number.isRequired,
    triangleSide: (0, _propTypes.oneOf)(["top", "right", "bottom", "left"]),
    triangleSize: _propTypes.number,
    flipToContainer: (0, _propTypes.oneOf)(["parent", "viewport", false]),
    nudgeToContain: (0, _propTypes.oneOf)(["parent", "viewport", false])
  }, props, "prop", "calculatePopupOffsets"); // get the width and height of this popup from the DOM
  // using offsetWidth/offsetHeight isntead of getBoundingClientRect because offsetWidth doesn't account for scale(0.9)

  var width = popup.offsetWidth;
  var height = popup.offsetHeight; // common calculations

  var popupOnTop = top - height - triangleSize - offset;
  var popupOnBottom = top + triangleSize + offset;
  var popupOnLeft = left - width - triangleSize - offset;
  var popupOnRight = left + triangleSize + offset; // calculate where the top of the popup should be based on top/left

  var relativeTop = triangleSide === "bottom" ? popupOnTop : triangleSide === "top" ? popupOnBottom : top - height / 2; //  left or right

  var relativeLeft = triangleSide === "right" ? popupOnLeft : triangleSide === "left" ? popupOnRight : left - width / 2; // center

  var realRight = relativeLeft + width;
  var realBottom = relativeTop + height; // if we don't need to do complicated math

  if (!flipToContain && !nudgeToContain) {
    // return with just the basic stuff
    return {
      relativeTop: relativeTop,
      relativeLeft: relativeLeft,
      triangleSide: triangleSide,
      triangleOffset: 0,
      popupTop: relativeTop,
      popupLeft: relativeLeft,
      adjustedTop: relativeTop,
      adjustedLeft: relativeLeft
    };
  } // get the width/height of the parent container div


  var parent = popup.parentNode;
  var parentWidth = parent.clientWidth;
  var parentHeight = parent.offsetHeight; // client height of body will only be the viewport height

  var parentClientRect = parent.getBoundingClientRect();
  var topBottom = triangleSide === "top" || triangleSide === "bottom";
  var leftRight = triangleSide === "left" || triangleSide === "right"; // these values should be "parent", "viewport", or ""/false

  var horizontalOverflow = topBottom ? nudgeToContain : flipToContain;
  var verticalOverflow = leftRight ? nudgeToContain : flipToContain; // find what is considered to be "overflowed", the parent, or the viewport

  var referencePoints = {
    top: verticalOverflow === "viewport" ? parentClientRect.top : 0,
    left: horizontalOverflow === "viewport" ? parentClientRect.left : 0,
    bottom: verticalOverflow === "viewport" ? parentHeight - (parentClientRect.bottom - window.innerHeight) : verticalOverflow === "parent" ? parentHeight : 0,
    right: horizontalOverflow === "viewport" ? parentWidth - (parentClientRect.right - window.innerWidth) : horizontalOverflow === "parent" ? parentWidth : 0
  }; // the amounts that this popup is outside of it's parent or the viewport. (positive number are outside)

  var overflow = {
    top: -(referencePoints.top + relativeTop),
    right: -(referencePoints.right - realRight),
    bottom: -(referencePoints.bottom - realBottom),
    left: -(referencePoints.left + relativeLeft)
  }; // calculate where the popup should go
  // start with adjustedLeft as relativeLeft before nudging

  var adjustedTop = relativeTop;
  var adjustedLeft = relativeLeft;
  var triangleOffset = 0;
  var newTriangleSide = triangleSide; // make a copy of this so we can override it if it flips
  // don't nudge the popup too far if the point the popup is supposed to be
  // pointing at is off the screen

  function getNudge(overflow, heightOrWidth) {
    var BORDER_RADIUS = 6;
    return Math.min(overflow, heightOrWidth / 2 - triangleSize - BORDER_RADIUS);
  } // if there is an overflow on the right, adjust the popup and triangle position


  if (overflow.right > 0) {
    if (triangleSide === "top" || triangleSide === "bottom") {
      var nudge = getNudge(overflow.right, width);
      adjustedLeft = relativeLeft - nudge;
      triangleOffset = nudge;
    } // for left, flip the popup
    else if (triangleSide === "left" && flipToContain) {
        newTriangleSide = "right";
        adjustedLeft = popupOnLeft;
      }
  } // if there is an overflow on the left, adjust the popup and triangle position


  if (overflow.left > 0) {
    if (triangleSide === "top" || triangleSide === "bottom") {
      var _nudge = getNudge(overflow.left, width);

      adjustedLeft = relativeLeft + _nudge;
      triangleOffset = -_nudge;
    } // for right, flip the popup
    else if (triangleSide === "right" && flipToContain) {
        newTriangleSide = "left";
        adjustedLeft = popupOnRight;
      }
  } // if there is an overflow on the bottom


  if (overflow.bottom > 0) {
    // for left/right, butt the popup against the bottom
    if (triangleSide === "left" || triangleSide === "right") {
      var _nudge2 = getNudge(overflow.bottom, height);

      adjustedTop = relativeTop - _nudge2;
      triangleOffset = _nudge2;
    } // for top, flip the popup
    else if (triangleSide === "top" && flipToContain) {
        newTriangleSide = "bottom";
        adjustedTop = popupOnTop;
      }
  } // if there is an overflow on the top


  if (overflow.top > 0) {
    if (triangleSide === "left" || triangleSide === "right") {
      var _nudge3 = getNudge(overflow.top, height);

      adjustedTop = relativeTop + _nudge3;
      triangleOffset = -_nudge3;
    } // for bottom, flip the popup


    if (triangleSide === "bottom" && flipToContain) {
      newTriangleSide = "top";
      adjustedTop = popupOnBottom;
    }
  } // return all the measurements


  return {
    relativeTop: relativeTop,
    relativeLeft: relativeLeft,
    adjustedTop: adjustedTop,
    adjustedLeft: adjustedLeft,
    triangleOffset: nudgeToContain ? triangleOffset : 0,
    popupTop: leftRight && nudgeToContain || topBottom && flipToContain ? adjustedTop : relativeTop,
    popupLeft: topBottom && nudgeToContain || leftRight && flipToContain ? adjustedLeft : relativeLeft,
    triangleSide: flipToContain ? newTriangleSide : triangleSide
  };
} // element.closest polygill


if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (selector) {
    var el = this;

    while (el) {
      if (el.matches(selector)) {
        return el;
      }

      el = el.parentElement;
    }
  };
}

},{"prop-types":"prop-types"}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _marked = _interopRequireDefault(require("marked"));

var S = _interopRequireWildcard(require("./RankHeaderStyles.jsx"));

var _styledComponents = require("styled-components");

var _propTypes = require("prop-types");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  children: _propTypes.node,
  rank: _propTypes.node,
  color: _propTypes.string,
  description: _propTypes.string,
  pdfUrl: _propTypes.string
};

var RankHeader = function RankHeader(props) {
  var children = props.children,
      rank = props.rank,
      color = props.color,
      description = props.description,
      pdfUrl = props.pdfUrl,
      rest = _objectWithoutProperties(props, ["children", "rank", "color", "description", "pdfUrl"]);

  return _react.default.createElement(S.Container, rest, _react.default.createElement(_styledComponents.ThemeProvider, {
    theme: {
      color: color
    }
  }, _react.default.createElement(S.Header, {
    hasRank: !R.isNil(rank)
  }, children, _react.default.createElement(S.RankHolder, {
    isHidden: R.isNil(rank)
  }, _react.default.createElement(S.RankText, null, "rank"), _react.default.createElement(S.Rank, null, rank || _react.default.createElement("span", null, "\xA0"))))), description && _react.default.createElement(S.DomainDescription, null, _react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: (0, _marked.default)(description)
    }
  }), pdfUrl && _react.default.createElement("p", null, "Learn more in the", " ", _react.default.createElement("i", null, _react.default.createElement("a", {
    href: pdfUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "2024 KIDS COUNT Data Book")), ".")));
};

RankHeader.propTypes = propTypes;
var _default = RankHeader;
exports.default = _default;

},{"./RankHeaderStyles.jsx":42,"marked":"marked","prop-types":"prop-types","ramda":"ramda","react":"react","styled-components":"styled-components"}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomainDescription = exports.Rank = exports.RankText = exports.RankHolder = exports.Header = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = require("../../styles/color.js");

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "RankHeaderStyles__Container",
  componentId: "qfgave-0"
})(["padding:20px 0 40px;cursor:", ";"], function (props) {
  return props.isLink ? "pointer" : "default";
});

exports.Container = Container;

var Header = _styledComponents.default.div.withConfig({
  displayName: "RankHeaderStyles__Header",
  componentId: "qfgave-1"
})(["display:flex;align-items:center;color:", ";font-size:20px;font-weight:700;letter-spacing:1px;line-height:1.2;text-transform:uppercase;border-bottom-width:4px;border-bottom-color:", ";border-bottom-style:solid;"], _color.caseyGrey, function (props) {
  return props.theme.color;
});

exports.Header = Header;

var RankHolder = _styledComponents.default.div.withConfig({
  displayName: "RankHeaderStyles__RankHolder",
  componentId: "qfgave-2"
})(["align-self:flex-end;padding:6px 20px 0;margin-left:auto;color:", ";text-align:center;background-color:", ";opacity:", ";"], function (props) {
  return (0, _polished.readableColor)(props.theme.color);
}, function (props) {
  return props.theme.color;
}, function (props) {
  return props.isHidden ? 0 : 1;
});

exports.RankHolder = RankHolder;

var RankText = _styledComponents.default.div.withConfig({
  displayName: "RankHeaderStyles__RankText",
  componentId: "qfgave-3"
})(["font-size:18px;font-weight:300;letter-spacing:0.6px;"]);

exports.RankText = RankText;

var Rank = _styledComponents.default.div.withConfig({
  displayName: "RankHeaderStyles__Rank",
  componentId: "qfgave-4"
})(["font-size:30px;letter-spacing:1px;"]);

exports.Rank = Rank;

var DomainDescription = _styledComponents.default.div.withConfig({
  displayName: "RankHeaderStyles__DomainDescription",
  componentId: "qfgave-5"
})(["width:700px;max-width:100%;margin:15px auto 60px;font-size:18px;"]);

exports.DomainDescription = DomainDescription;

},{"../../styles/color.js":51,"polished":"polished","styled-components":"styled-components"}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var S = _interopRequireWildcard(require("./RankingStyles.js"));

var _domains = require("../../common/domains.js");

var _locations = require("../../common/locations.js");

var _color = require("../../styles/color.js");

var _InstructionText = _interopRequireDefault(require("../../components/InstructionText/InstructionText.jsx"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  domain: _domains.domainMetadataShape.isRequired,
  hoveredStateId: _propTypes.string,
  selectedStateId: _propTypes.string,
  onStateClick: _propTypes.func.isRequired,
  onStateHover: _propTypes.func.isRequired,
  quartiles: (0, _propTypes.arrayOf)((0, _propTypes.arrayOf)(_locations.locationRankShape))
};

var Ranking = function Ranking(props) {
  var domain = props.domain,
      hoveredStateId = props.hoveredStateId,
      onStateClick = props.onStateClick,
      onStateHover = props.onStateHover,
      selectedStateId = props.selectedStateId,
      quartiles = props.quartiles;
  return _react.default.createElement(S.Container, null, _react.default.createElement(S.Title, null, "State Rankings on ", domain.name, " "), _react.default.createElement(_InstructionText.default, null, domain.rankInstruction), _react.default.createElement(S.Ranking, null, quartiles.map(function (q, i) {
    return _react.default.createElement(S.Quartile, {
      key: i
    }, _react.default.createElement(S.QuartileTitle, {
      color: (0, _color.quartileColor)(domain.id, i)
    }, "".concat(getNumberWithOrdinal(i + 1), " quartile")), q.map(function (location, j) {
      return _react.default.createElement(S.State, {
        key: location.name,
        onClick: function onClick() {
          return onStateClick(location);
        },
        isSelected: selectedStateId === location.id,
        isHovered: hoveredStateId === location.id,
        onMouseEnter: function onMouseEnter() {
          return onStateHover(location.id);
        },
        onMouseLeave: function onMouseLeave() {
          return onStateHover();
        }
      }, location.rank, ". ", location.name);
    }));
  })));
};

Ranking.propTypes = propTypes;
var _default = Ranking;
exports.default = _default;

function getNumberWithOrdinal(n) {
  var s = ["th", "st", "nd", "rd"];
  var v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

},{"../../common/domains.js":6,"../../common/locations.js":10,"../../components/InstructionText/InstructionText.jsx":28,"../../styles/color.js":51,"./RankingStyles.js":44,"prop-types":"prop-types","react":"react"}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.State = exports.QuartileTitle = exports.Quartile = exports.Ranking = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = require("../../styles/color.js");

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "RankingStyles__Container",
  componentId: "ii0af5-0"
})([""]);

exports.Container = Container;

var Ranking = _styledComponents.default.div.withConfig({
  displayName: "RankingStyles__Ranking",
  componentId: "ii0af5-1"
})(["display:grid;grid-template-columns:1fr 1fr 1fr 1fr;grid-gap:12px;@media (max-width:675px){grid-template-columns:1fr 1fr;}"]);

exports.Ranking = Ranking;

var Quartile = _styledComponents.default.div.withConfig({
  displayName: "RankingStyles__Quartile",
  componentId: "ii0af5-2"
})(["padding:0px 0 12px;box-sizing:border-box;"]);

exports.Quartile = Quartile;

var QuartileTitle = _styledComponents.default.div.withConfig({
  displayName: "RankingStyles__QuartileTitle",
  componentId: "ii0af5-3"
})(["padding:8px 12px;margin-bottom:12px;color:", ";background-color:", ";"], function (props) {
  return (0, _polished.readableColor)(props.color);
}, function (props) {
  return props.color;
});

exports.QuartileTitle = QuartileTitle;

var State = _styledComponents.default.button.withConfig({
  displayName: "RankingStyles__State",
  componentId: "ii0af5-4"
})(["display:block;padding:3px 0;color:inherit;font-size:16px;font-weight:300;text-decoration:", ";background-color:transparent;border:0;cursor:pointer;white-space:nowrap;"], function (props) {
  return props.isHovered || props.isSelected ? "underline" : "none";
});

exports.State = State;

var Title = _styledComponents.default.h2.withConfig({
  displayName: "RankingStyles__Title",
  componentId: "ii0af5-5"
})(["margin:0 0 30px;padding:20px 0 10px;color:", ";font-size:20px;font-weight:700;letter-spacing:1px;line-height:1.2;text-align:left;text-transform:uppercase;"], _color.caseyGrey);

exports.Title = Title;

},{"../../styles/color.js":51,"polished":"polished","styled-components":"styled-components"}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _downshift = require("downshift");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Example usage:
 *
 *   const items = ["Red", "Orange", "Yellow", "Green", "Blue", "Indigo", "Violet"];
 *
 *   <Select
 *     selectProps={{
 *       items,
 *       itemToString: d => d,
 *       initialSelectedItem: "Red",
 *     }}
 *     style={{ width: 400 }}
 *   />
 *
 *  (also see Select.stories.jsx for example usage)
 *  (see https://github.com/downshift-js/downshift/tree/master/src/hooks/useSelect for docs)
 */
var propTypes = {
  className: _propTypes.string,
  disabled: _propTypes.bool,
  itemToId: _propTypes.func,
  // can use this instead of itemToString to identify an item
  label: _propTypes.node,
  // onChange shortcut for selectProps.onSelectedItemChange(item.selectedItem)
  // if this is used, you don't need to provide selectProps.onSelectedItemChange
  onChange: _propTypes.func,
  placeholder: _propTypes.node,
  renderItem: _propTypes.func,
  // (item, isSelected) => node
  selectProps: (0, _propTypes.shape)({
    items: (0, _propTypes.arrayOf)(_propTypes.any).isRequired,
    itemToString: _propTypes.func.isRequired // anything else to go in to useSelect, like onSelectedItemChange or selectedItem
    // see https://github.com/downshift-js/downshift/tree/master/src/hooks/useSelect

  }).isRequired // useSelect props

};
var defaultProps = {
  disabled: false
};

var Select = function Select(props) {
  var className = props.className,
      disabled = props.disabled,
      label = props.label,
      onChange = props.onChange,
      placeholder = props.placeholder,
      selectProps = props.selectProps,
      otherProps = _objectWithoutProperties(props, ["className", "disabled", "label", "onChange", "placeholder", "selectProps"]);

  var items = selectProps.items,
      itemToString = selectProps.itemToString;
  var selectState = (0, _downshift.useSelect)(_objectSpread({}, selectProps, {
    onSelectedItemChange: function onSelectedItemChange(changes) {
      // call both functions, the consumer should only provide one...
      selectProps.onSelectedItemChange && selectProps.onSelectedItemChange(changes);
      onChange && onChange(changes.selectedItem);
    }
  }));
  var itemToId = props.itemToId || itemToString;

  var renderItem = props.renderItem || function (item) {
    return _react.default.createElement(_react.default.Fragment, null, itemToId(selectedItem) === itemToId(item) && _react.default.createElement("div", {
      className: "select__checkmark"
    }), itemToString(item));
  };

  var isOpen = selectState.isOpen,
      selectedItem = selectState.selectedItem,
      getToggleButtonProps = selectState.getToggleButtonProps,
      getLabelProps = selectState.getLabelProps,
      getMenuProps = selectState.getMenuProps,
      highlightedIndex = selectState.highlightedIndex,
      getItemProps = selectState.getItemProps,
      toggleMenu = selectState.toggleMenu,
      closeMenu = selectState.closeMenu,
      selectItem = selectState.selectItem;
  var hasSelection = selectedItem !== undefined && selectedItem !== null;
  var buttonText = itemToString(selectedItem) || placeholder;
  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)("select", className, {
      "select--open": isOpen,
      "select--no-selection": !hasSelection
    })
  }, otherProps), label && _react.default.createElement("label", _extends({
    className: "select__label"
  }, getLabelProps()), label), _react.default.createElement("div", {
    className: "select__dropdown"
  }, _react.default.createElement("div", {
    className: "select__button-holder"
  }, _react.default.createElement("button", _extends({
    type: "button",
    className: "select__button",
    onClick: toggleMenu
  }, getToggleButtonProps({
    "aria-label": itemToString(selectedItem),
    disabled: disabled,
    onKeyDown: function onKeyDown(event) {
      if (event.key === "Escape") {
        // Prevent Downshift's default "Escape" behavior because it
        // sets the selectedItem to be null
        event.nativeEvent.preventDownshiftDefault = true;
        closeMenu();
      }
    }
  })), _react.default.createElement("div", {
    className: "select__button-text",
    title: buttonText
  }, buttonText)), hasSelection && placeholder && _react.default.createElement("div", {
    className: "select__clear-holder"
  }, _react.default.createElement("button", {
    className: "select__clear",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      selectItem(null);
    }
  }))), _react.default.createElement("ul", _extends({
    className: "select__menu"
  }, getMenuProps()), items.map(function (item, index) {
    return _react.default.createElement("li", _extends({
      key: itemToString(item) || itemToId(item),
      className: (0, _classnames.default)("select__menu-item", {
        "select__menu-item--highlighted": highlightedIndex === index,
        "select__menu-item--selected": itemToId(selectedItem) === itemToId(item)
      })
    }, getItemProps({
      index: index,
      item: item
    })), renderItem(item, itemToId(selectedItem) === itemToId(item)));
  }))));
};

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
var _default = Select;
exports.default = _default;

},{"classnames":"classnames","downshift":"downshift","prop-types":"prop-types","react":"react"}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = _interopRequireDefault(require("ramda"));

var _propTypes = require("prop-types");

var _RankHeader = _interopRequireDefault(require("../RankHeader/RankHeader.jsx"));

var _locations = require("../../common/locations.js");

var _domains = require("../../common/domains.js");

var _color = require("../../styles/color.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  domain: _domains.domainMetadataShape.isRequired,
  location: _locations.locationRankShape,
  pdfUrl: _propTypes.string
};

var StateHeader = function StateHeader(props) {
  var domain = props.domain,
      location = props.location,
      pdfUrl = props.pdfUrl;

  var locationName = _ramda.default.prop("name", location);

  var color = location.id === _locations.usa.id ? (0, _color.domainColor)(domain.id) : (0, _color.quartileColor)(domain.id, _ramda.default.prop("quartile", location));

  var rank = _ramda.default.prop("rank", location);

  return _react.default.createElement(_RankHeader.default, {
    color: color,
    rank: rank,
    description: location.id === _locations.usa.id ? domain.nationDescription : domain.description,
    pdfUrl: pdfUrl
  }, domain.name, locationName && " in ".concat(location.useThe ? "the " : "").concat(locationName));
};

StateHeader.propTypes = propTypes;
var _default = StateHeader;
exports.default = _default;

},{"../../common/domains.js":6,"../../common/locations.js":10,"../../styles/color.js":51,"../RankHeader/RankHeader.jsx":41,"prop-types":"prop-types","ramda":"ramda","react":"react"}],47:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _AppStateContext = require("./lib/AppStateContext.jsx");

var _App = _interopRequireDefault(require("./App.jsx"));

var _AppState = require("./AppState.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mountElement = document.querySelector(".js-react-mount");
var dataRoot = mountElement.getAttribute("data-root") || "data";
var pdfUrl = mountElement.getAttribute("data-pdf-url");
fetch(dataRoot + "/data.json").then(function (res) {
  return res.json();
}).then(function (data) {
  _reactDom.default.render(_react.default.createElement(_AppStateContext.AppStateProvider, {
    initialState: _objectSpread({}, _AppState.initialState, {
      data: data,
      dataRoot: dataRoot
    }),
    reducer: _AppState.reducer,
    actions: _AppState.actions,
    mapStateToUrl: _AppState.mapStateToUrl,
    handleUrlChange: _AppState.handleUrlChange
  }, _react.default.createElement(_App.default, {
    pdfUrl: pdfUrl
  })), document.querySelector(".js-react-mount"));
});
/* development for generators/munchers below */

/* indicators-metadata.csv and generate data.csv and race-data.csv*/
// import R from "ramda";
// import munchIndicatorsMetadata from "../../data/munch/munchIndicatorsMetadata.js";
// import generateData from "../../data/generate/generateData.js";
// import generateRaceData from "../../data/generate/generateRaceData.js";
//
// fetch("/data/csv/indicators-metadata.csv")
//   .then(res => res.text())
//   .then(munchIndicatorsMetadata)
//   .then(R.tap(data => console.log("indicatorMetadata", data)))
//   .then(data => [generateData(data), generateRaceData(data)])
//   .then(
//     R.tap(
//       ([data, raceData]) =>
//         console.log("data", data) && console.log("race-data.csv", raceData)
//     )
//   );

/* generate ranks.csv */
// import generateRanks from "../../data/generate/generateRanks.js";
// console.log(generateRanks());

/* munch data.csv, domain-ranks.csv, and race-data.csv  */
// import munchData from "../../data/munch/munchData.js";
// import R from "ramda";
// Promise.all([
//   fetch("/data/csv/data.csv"),
//   fetch("/data/csv/regions.csv"),
//   fetch("/data/csv/domain-ranks.csv"),
//   fetch("/data/csv/race-data.csv")
// ])
//   .then(results => Promise.all(results.map(res => res.text())))
//   .then(data => munchData(...data))
//   .then(R.tap(results => console.log("munch", results)));

},{"./App.jsx":1,"./AppState.js":2,"./lib/AppStateContext.jsx":48,"react":"react","react-dom":"react-dom"}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppStateProvider = AppStateProvider;
exports.AppStateConsumer = exports.AppStateContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _useQueryStringSync = _interopRequireDefault(require("./useQueryStringSync.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * AppStateContext
 *
 * Usage for Context provider:
 *   import { AppStateProvider } from "./AppStateContext.jsx";
 *
 *   <AppStateProvider>
 *     <App />
 *   </AppStateProvider>
 *
 *
 * Usage for Context Consumer:
 *  import { useContext } from "react";
 *  import { AppStateContext } from "./AppStateContext.jsx";
 *
 *  const { appState, setAppState } = useContext(AppStateContext);
 *
 * or
 *
 *  import { AppStateConsumer } from "./AppStateContext.jsx";
 *
 *  <AppStateConsumer>
 *    ({ appState, setAppState }) => { ... }
 *  </AppStateConsumer>
 *
 */

/* Context */
var AppStateContext = _react.default.createContext();
/* Consumer */


exports.AppStateContext = AppStateContext;
var AppStateConsumer = AppStateContext.Consumer;
/* Provider */

exports.AppStateConsumer = AppStateConsumer;

function AppStateProvider(props) {
  var initialState = props.initialState,
      reducer = props.reducer,
      actions = props.actions,
      mapStateToUrl = props.mapStateToUrl,
      handleUrlChange = props.handleUrlChange;

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      appState = _useReducer2[0],
      dispatch = _useReducer2[1];

  var getContext = function getContext() {
    return {
      appState: appState,
      actions: actions,
      dispatch: dispatch
    };
  };

  (0, _useQueryStringSync.default)({
    mapStateToUrl: mapStateToUrl,
    handleUrlChange: handleUrlChange,
    initialState: initialState,
    context: getContext()
  });
  return _react.default.createElement(AppStateContext.Provider, {
    value: getContext()
  }, props.children);
}

AppStateProvider.propTypes = {
  children: _propTypes.any,
  reducer: _propTypes.func.isRequired,
  initialState: _propTypes.any,
  actions: (0, _propTypes.objectOf)(_propTypes.func),
  mapStateToUrl: _propTypes.func,
  handleUrlChange: _propTypes.func
};

},{"./useQueryStringSync.js":50,"prop-types":"prop-types","react":"react"}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useBoundingClientRect;

var _react = require("react");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * useBoundingClientRect, react hook
 * given an element, return the dimensions.
 * see https://developer.mozilla.org/en-US/docs/Web/API/DOMRect
 * @return {Object} { width, height, x, y, top, right, bottom, left } of the element
 */
function useBoundingClientRect() {
  var ref = (0, _react.useRef)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  var measure = function measure() {
    if (ref.current) {
      setDimensions(ref.current.getBoundingClientRect());
    } else {
      setDimensions(null);
    }
  };

  (0, _react.useLayoutEffect)(measure, [ref.current]);
  (0, _react.useEffect)(function () {
    var handleResize = (0, _lodash.default)(measure, 100);
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return [ref, dimensions];
}

},{"lodash.debounce":"lodash.debounce","react":"react"}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useQueryString;

var _react = require("react");

var _queryString = _interopRequireDefault(require("query-string"));

var _compareUrls = _interopRequireDefault(require("compare-urls"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Problem: handleUrlChange can dispatch multiple actions when the user clicks
 * back in their browser.  This causes a new history entry for each dispatch,
 * which is wrong.
 * To solve this, we're debouncing the pushState, but is this the best solution?
 */
var debouncedPushState = (0, _lodash.default)(function (url) {
  //if the url is different, pushState the new url
  if (!(0, _compareUrls.default)(url, window.location.href)) {
    history.pushState(null, null, url);
  }
}, 500);

var buildUrl = function buildUrl(origin, pathname, queryString) {
  var url = origin;

  if (pathname && pathname.length) {
    if (pathname[pathname.length - 1] === "/") {
      pathname = pathname.substring(0, pathname.length - 1);
    }

    url += pathname;
  }

  if (queryString && queryString.length) {
    url += "?".concat(queryString);
  }

  return url;
};

function useQueryString(_ref) {
  var mapStateToUrl = _ref.mapStateToUrl,
      handleUrlChange = _ref.handleUrlChange,
      initialState = _ref.initialState,
      context = _ref.context;
  // we need to have special treatment on the first render to read from the URL
  var hasInitializedRef = (0, _react.useRef)(false);

  var getQueryString = function getQueryString(state) {
    // don't include any default values in the url
    var query = Object.keys(state).filter(function (key) {
      return state[key] !== initialState[key];
    }).reduce(function (obj, key) {
      return _objectSpread({}, obj, _defineProperty({}, key, state[key]));
    }, {});
    return _queryString.default.stringify(mapStateToUrl(query));
  };

  (0, _react.useEffect)(function () {
    // don't update on the first render
    if (mapStateToUrl && hasInitializedRef.current) {
      var url = buildUrl(window.location.origin, window.location.pathname, getQueryString(context.appState));
      debouncedPushState(url);
    } // open the gate after the first render


    if (!hasInitializedRef.current) {
      hasInitializedRef.current = true;
    }
  }, [context.appState, initialState, mapStateToUrl]);
  var handlePopState = (0, _react.useCallback)(function (event) {
    if (handleUrlChange) {
      // get the values from the url
      var searchParams = _queryString.default.parse(window.location.search); // call user function to handle the url change.
      // This function will probably call dispatch, potentially many times


      handleUrlChange(searchParams, context, event);
    }
  }, [context, handleUrlChange]); // run handlePopState once initially to get the values from the url

  (0, _react.useEffect)(handlePopState, []); // also attach the popstate handler.  handlePopState depends on `context` to make sure context
  // isn't stale when handleUrlChange is fired, so this needs a separate useEffect

  (0, _react.useEffect)(function () {
    window.addEventListener("popstate", handlePopState);
    return function () {
      return window.removeEventListener("popstate", handlePopState);
    };
  }, [context, handlePopState] // handlePopState depends on the context
  );
}

},{"compare-urls":"compare-urls","lodash.debounce":"lodash.debounce","query-string":"query-string","react":"react"}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caseyGrey = exports.quartileColor = exports.domainColor = void 0;

var _ramda = _interopRequireDefault(require("ramda"));

var _domains = require("../common/domains.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var domainColor = function domainColor(domainId) {
  var selectedDomain = _ramda.default.find(_ramda.default.propEq("id", domainId), _domains.domains);

  return _ramda.default.prop("color", selectedDomain);
};

exports.domainColor = domainColor;

var quartileColor = _ramda.default.curry(function (domainId, quartile) {
  var selectedDomain = _ramda.default.find(_ramda.default.propEq("id", domainId), _domains.domains);

  return _ramda.default.compose(_ramda.default.defaultTo("#ccc"), _ramda.default.nth(quartile), _ramda.default.defaultTo([]), _ramda.default.prop("quartileColors"))(selectedDomain);
});

exports.quartileColor = quartileColor;
var caseyGrey = "#3f3e3c";
exports.caseyGrey = caseyGrey;

},{"../common/domains.js":6,"ramda":"ramda"}]},{},[47]);
